// import React, { useEffect, useRef, useState } from 'react';
// import { HiLink } from 'react-icons/hi';
// import { IoAlert } from "react-icons/io5";
// import { MdPsychology } from "react-icons/md";
// import { getCreator } from 'utils/creator/creator';
// import { getCompany } from 'utils/company/companyService';
// import { FaLightbulb } from "react-icons/fa";
// import { FaChartLine  } from 'react-icons/fa';
// import { FaClipboardList  } from 'react-icons/fa';
// import { FaPuzzlePiece } from "react-icons/fa6";
// import { MdOutlineSwipe } from "react-icons/md";
// import { TbDragDrop2 } from "react-icons/tb";
// import {
//   Box,
//   Text,
//   Flex,
//   Button,
//   Icon,
//   List,
//   ListItem,
//   Input,
//   Table,
//   Thead,
//   Tr,
//   Td,
//   Tbody,
//   Th,
//   TableContainer,
//   Checkbox,
//   Textarea,
//   Tooltip,
//   useToast,
// } from '@chakra-ui/react';
// import Select, { GroupBase, OptionsOrGroups } from 'react-select';
// import {
//   MdAdd,
//   MdArrowBack,
//   MdArrowForward,
//   MdOutlineStickyNote2,
//   MdDelete,
// } from 'react-icons/md';

// import { BiSolidDuplicate } from 'react-icons/bi';

// import Menu from '../components/Navigate';

// import { TbHandClick, TbMessages } from 'react-icons/tb';
// import StrightConector from '../components/dragNdrop/strightConector';
// import { FaAward } from 'react-icons/fa6';
// import { MdAssessment } from "react-icons/md";
// import { MdOutlineAssessment } from "react-icons/md";
// interface PropsInteraction {
//   targetSequence?: any;
//   reviews?: any;
//   id?: number;
//   language?: any;
//   seq?: any;
//   index?: number;
//   name?: any;
//   number?: any;
//   handleNDI?: any;
//   dummySequence?: any;
//   getSeq?: any;
//   duplicateSeq?: any;
//   delSeq?: any;
//   input?: any;
//   handleInput?: any;
//   handleSelect?: any;
//   characterOption?: any;
//   alphabet?: any;
//   setAlphabet?: any;
//   animateBtn?: any;
//   setAnimateBtn?: any;
//   interactionBlock?: any;
//   setInteractionBlock?: any;
//   formData?: any;
//   handleBlockRoll: any;
//   handleResponseRoll: any;
//   handleQuestionEmotion: any;
//   handleOptionEmotion: any;
//   handleResponseEmotion: any;
//   handleCheckBox: any;
//   inputtextValue: any;
//   setNavigation: any;
//   handleBlock: any;
//   handleOptionVoice: any;
//   handleQuestionVoice: any;
//   countalphabet: any;
//   setAlphabetCount: any;
//   items: any;
//   handleSelectBlock: any;
//   handleTagsChange: any;
//   showSelectBlock?: any;
//   setSelectBlock?: any;
//   validation?: any;
//   handleMiniNDI?: any;
//   currentseq?: any;
//   ShowReview?: any;
//   blockOnFocusHanlder: any;
//   blockOnBlurHanlder: any;
//   showReflectionQuestions:any;
// }
// const customButtonStyles = {
//   display: 'flex',
//   alignItems: 'center',
//   borderRadius: '15px',
//   borderColor: '#ccc', // Optional: Change border color for disabled state
//   borderWidth: '1px', // Add this line to set the border width
//   borderStyle: 'solid', // Add this line to set the border style
//   cursor: 'not-allowed', // Optional: Change cursor for disabled state
//   padding: '5px 10px',
//   width: '144px',
//   // textAlign: "left",
//   outerWidth: '10px',
//   outline: 'none',
// };
// interface Option {
//   qpOptionId: number;
//   qpSequence: string;
//   qpQuestNo: number;
//   qpOptions: string;
//   qpResponse: string;
//   contentOptionTextData: { textId: number; content: string }[];
// }

// const InteractionCompo: React.FC<PropsInteraction> = ({
//   targetSequence,
// showReflectionQuestions,
//   language,
//   seq,
//   index,
//   number,
//   dummySequence,
//   name,
//   handleInput,

//   input,
//   getSeq,
//   duplicateSeq,
//   delSeq,

//   alphabet,
//   setAlphabet,

//   interactionBlock,
//   setInteractionBlock,
//   formData,
//   handleBlockRoll,
//   handleQuestionEmotion,
//   handleOptionEmotion,
//   handleResponseEmotion,
//   handleCheckBox,
//   setNavigation,
//   handleBlock,
//   inputtextValue,

//   countalphabet,
//   setAlphabetCount,
//   items,
//   handleSelectBlock,
//   handleResponseRoll,
//   handleNDI,

//   showSelectBlock,

//   validation,
// }) => {
//   const initial = {
//     [`block${index}`]: [''],
//   };
//   const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
//   label: `Scenario ${i + 1}`,
//   value: `Scenario ${i + 1}`,
// }));
//   const toast = useToast();
//   const textareaRef = useRef(null);
//   const targetRef = useRef(null);
//   const [textareaHeight, setTextareaHeight] = useState<number>(0);
//   const [keyUp, setKeyUp] = useState<any>(),
//     [upComing, setUpComing] = useState<any>([]),
//     [showAlpha, setShowAlpha] = useState<any>(['A']),
//     [state, setState] = useState<any>(initial);

//   const [matchingBlockContent, setMatchingBlockContent] = useState('');
//   const [filteredOptions, setFilteredOptions] = useState<Option[] | null>(null);
//   const [ResponseOptions, setResponseOptions] = useState<Option[] | null>(null);

//   useEffect(() => {
//     const blocks: any = [];
//     dummySequence.forEach((item: any) => {
//       blocks[item] = [''];
//     });

//     setState({ ...state, blocks });
//   }, [number]);


//    const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);



//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     const secondarycount = countalphabet + 1;
//     setAlphabetCount(secondarycount);
//     const lastElement = alphabet
//       .filter((item: any) => item.seqs === seq.id)
//       .reduce(
//         (acc: any, cur: any) => (cur.option > acc.option ? cur : acc),
//         alphabet[0],
//       );

//     const currentAlpha = lastElement.option;
//     const currentLetter = currentAlpha.charAt(currentAlpha.length - 1);
//     let nextLetter = '';
//     let upComingAlpha = '';
//     if (currentLetter.charCodeAt(0) >= 90) {
//       nextLetter = 'A';
//       upComingAlpha = 'A';
//     } else {
//       nextLetter = String.fromCharCode(currentLetter.charCodeAt(0) + 1);
//       upComingAlpha = String.fromCharCode(nextLetter.charCodeAt(0) + 1);
//     }
//     const newAlpha = [
//       ...alphabet,
//       { seq: seq.id, option: `${currentAlpha}${nextLetter}` },
//     ];

//     setAlphabet((prev: any) => [
//       ...prev,
//       { seqs: seq.id, option: nextLetter, secondaryId: secondarycount },
//     ]);
//     setUpComing(upComingAlpha);

//     setShowAlpha([...showAlpha, nextLetter]);

//     if (nextLetter > 'Z') {
//     }
//   };

//   const handleKeyDown = (e: any) => {
//     setKeyUp(true);
//   };
//   const handleInter = (e: any) => {
//     const textarea = e.target;
//     textarea.style.height = `${textarea.scrollHeight}px`;
//   };
//   const handleFocusOut = () => {
//     setKeyUp(false);
//   };

//   const [options, setOptions] = useState([]);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [selectedrespoOption, setSelectedrespoOption] = useState(null);
//   useEffect(() => {
//     const newOptions = [
//       { value: 99999, altValue: 'Narrator', label: 'Narrator' },
//        { value: 9999, label: 'Mentor' },
//       // {
//       //   value: formData.gameNonPlayingCharacterId,
//       //   label: formData.gameNonPlayerName,
//       // },
//       ...(Array.isArray(formData?.gameNonPlayerOption)
//   ? formData.gameNonPlayerOption.map((npc: any) => ({
//       value: npc.gasId,
//       label: npc.name,
//     }))
//   : []),
//     ];

//     setOptions(newOptions);
//   }, [formData.gameNonPlayingCharacterId, formData.gameNonPlayerName]);

//   useEffect(() => {
//     const initialOption =
//       options.find((option) => {
//         const blockRoll = input?.[`Interaction${seq.input}`]?.blockRoll;

//         // Numeric comparison
//         if (!isNaN(blockRoll) && !isNaN(parseInt(blockRoll, 10))) {
//           return option.value === parseInt(blockRoll, 10);
//         }
//         // String comparison for altValue
//         else if (option.altValue === blockRoll) {
//           return true;
//         }
//         // Fallback to label comparison
//         else {
//           return option.label === formData.gameNonPlayerName;
//         }
//       }) || null;

//     const respoOption =
//       options.find((option) => {
//         const responseRoll = input?.[`Interaction${seq.input}`]?.responseRoll;

//         // Numeric comparison
//         if (!isNaN(responseRoll) && !isNaN(parseInt(responseRoll, 10))) {
//           return option.value === parseInt(responseRoll, 10);
//         }
//         // String comparison for altValue
//         else if (option.altValue === responseRoll) {
//           return true;
//         }
//         // Fallback to label comparison
//         else {
//           return option.label === formData.gameNonPlayerName;
//         }
//       }) || null;
//     setSelectedOption(initialOption);
//     setSelectedrespoOption(respoOption);
//   }, [options, seq.input, input]);

//   const emotionsOptions = [
//     { value: 'Talking', label: 'Talking', key: 1 },
//     { value: 'Asking', label: 'Asking', key: 2 },
//     { value: 'Agreeing', label: 'Agreeing', key: 3 },
//     { value: 'Saying no', label: 'Saying no', key: 4 },
//     { value: 'Happy', label: 'Happy', key: 5 },
//     { value: 'Disappointed', label: 'Disappointed', key: 6 },
//     { value: 'Angry', label: 'Angry', key: 7 },
//     { value: 'Talking02', label: 'Talking02', key: 9 },
//     { value: 'Idle', label: 'Idle', key: 8 },
//     { value: 'walk2', label: 'Walk', key: 10 }
//   ];

//   const deleteAndRearrange = (seqs: string, option: string) => {
//     // Filter out the deleted element

//     if (typeof input === 'object' && input !== null) {
//       // Find the iteration with the specified key
//       const iteration = input[`Interaction${seq.input}`];

//       if (iteration) {
//         // Ensure that optionsObject is an object
//         if (
//           typeof iteration.optionsObject === 'object' &&
//           iteration.optionsObject !== null
//         ) {
//           // Delete the specified optionKey from optionsObject
//           delete iteration?.optionsObject[option];
//           delete iteration?.ansObject[option];

//           if (
//             iteration.ansObject &&
//             iteration.ansObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.ansObject[option];
//           }

//           if (
//             iteration.feedbackObject &&
//             iteration.feedbackObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.feedbackObject[option];
//           }

//           if (
//             iteration.responseObject &&
//             iteration.responseObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.responseObject[option];
//           }
//           if (
//             iteration.responseObject &&
//             iteration.responseObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.responseObject[option];
//           }

//           if (
//             iteration.scoreObject &&
//             iteration.scoreObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.scoreObject[option];
//           }

//           if (
//             iteration.optionsemotionObject &&
//             iteration.optionsemotionObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.optionsemotionObject[option];
//           }

//           if (
//             iteration.responseemotionObject &&
//             iteration.responseemotionObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.responseemotionObject[option];
//           }

//           if (
//             iteration.optionTitleObject &&
//             iteration.optionTitleObject.hasOwnProperty(option)
//           ) {
//             delete iteration?.optionTitleObject[option];
//           }

//           if (
//             iteration.optionsvoiceObject &&
//             iteration.optionsvoiceObject.hasOwnProperty(option)
//           ) {
//             delete iteration.optionsvoiceObject[option];
//           }

//           // Get the remaining keys and sort them alphabetically
//           const remainingKeys = Object.keys(iteration.optionsObject).sort();

//           // Create a new optionsObject with the reordered keys
//           const reorderedOptionsObject: { [key: string]: any } = {};
//           const reorderedansObject: { [key: string]: any } = {};
//           const reorderedfeedbackObject: { [key: string]: any } = {};
//           const reorderedresponseObject: { [key: string]: any } = {};
//           const reorderedscoreObject: { [key: string]: any } = {};
//           const reorderedoptionsemotionObject: { [key: string]: any } = {};
//           const reorderedresponseemotionObject: { [key: string]: any } = {};
//           const reorderedoptionTitleObject: { [key: string]: any } = {};
//           const reorderedoptionVoiceObject: { [key: string]: any } = {};

//           let counter = 0;

//           Object.keys(iteration.optionsObject)
//             .sort()
//             .forEach((key) => {
//               const newKey = String.fromCharCode('A'.charCodeAt(0) + counter);

//               reorderedOptionsObject[newKey] = iteration.optionsObject[key]
//                 ? iteration.optionsObject[key]
//                 : undefined;
//               reorderedansObject[newKey] = iteration.ansObject[key]
//                 ? iteration.ansObject[key]
//                 : undefined;

//               reorderedfeedbackObject[newKey] = iteration.feedbackObject[key]
//                 ? iteration.feedbackObject[key]
//                 : undefined;

//               reorderedresponseObject[newKey] = iteration.responseObject[key]
//                 ? iteration.responseObject[key]
//                 : undefined;

//               reorderedscoreObject[newKey] = iteration.scoreObject[key]
//                 ? iteration.scoreObject[key]
//                 : undefined;

//               if (
//                 iteration.optionsemotionObject &&
//                 iteration.optionsemotionObject[key]
//               ) {
//                 reorderedoptionsemotionObject[newKey] =
//                   iteration.optionsemotionObject[key];
//               } else {
//                 // Handle the case where iteration.responseemotionObject or its property is undefined
//                 reorderedoptionsemotionObject[newKey] = undefined;
//               }

//               if (
//                 iteration.responseemotionObject &&
//                 iteration.responseemotionObject[key]
//               ) {
//                 reorderedresponseemotionObject[newKey] =
//                   iteration.responseemotionObject[key];
//               } else {
//                 // Handle the case where iteration.responseemotionObject or its property is undefined
//                 reorderedresponseemotionObject[newKey] = undefined;
//               }
//               reorderedoptionTitleObject[newKey] = iteration.optionTitleObject[
//                 key
//               ]
//                 ? iteration.optionTitleObject[key]
//                 : undefined;

//               if (
//                 iteration.optionsvoiceObject &&
//                 iteration.optionsvoiceObject[key]
//               ) {
//                 reorderedoptionVoiceObject[newKey] =
//                   iteration.optionsvoiceObject[key];
//               } else {
//                 // Handle the case where iteration.responseemotionObject or its property is undefined
//                 reorderedoptionVoiceObject[newKey] = undefined;
//               }

//               counter++;
//             });

//           // Set the reordered optionsObject
//           iteration.optionsObject = reorderedOptionsObject;
//           iteration.ansObject = reorderedansObject;
//           iteration.feedbackObject = reorderedfeedbackObject;
//           iteration.responseObject = reorderedresponseObject;
//           iteration.scoreObject = reorderedscoreObject;
//           iteration.optionsemotionObject = reorderedoptionsemotionObject;
//           iteration.responseemotionObject = reorderedresponseemotionObject;
//           iteration.optionTitleObject = reorderedoptionTitleObject;
//           iteration.optionsvoiceObject = reorderedoptionVoiceObject;
//         } else {
//           console.error('optionsObject is not an object');
//         }
//       } else {
//         console.error(`No iteration found with key 'Interaction${seqs}'`);
//       }
//     } else {
//       console.error('Input is not an object');
//     }

//     const updatedAlphabet = alphabet?.filter(
//       (item: any) => !(item.seqs === seqs && item.option === option),
//     );

//     // Get only the elements with the specific seqs ID
//     const filteredBySeqs = updatedAlphabet?.filter(
//       (item: any) => item.seqs === seqs,
//     );
//     if (filteredBySeqs.length === 0) {
//       return;
//     }

//     const rearrangedAlphabet = filteredBySeqs.map((item: any, index: any) => ({
//       ...item,
//       option: String.fromCharCode(65 + index), // Convert index to alphabet ('A', 'B', ...)
//     }));

//     setAlphabet((prevAlphabet: any[]) => {
//       const filteredPrevAlphabet = prevAlphabet?.filter(
//         (item) => item.seqs !== seqs,
//       );

//       const updatedAlphabet = filteredPrevAlphabet.concat(rearrangedAlphabet);

//       return updatedAlphabet;
//     });
//   }; //1998

//   // InteractionBlock Function
//   const handleDelResponse = () => {
//     setInteractionBlock({ ...interactionBlock, [`Resp${seq.input}`]: null });
//   };
//   const handleDelFeedback = () => {
//     setInteractionBlock({ ...interactionBlock, [`Feedbk${seq.input}`]: null });
//   };
//   const handleDelSkills = () => {
//     setInteractionBlock({ ...interactionBlock, [`Skills${seq.input}`]: null });
//   };
//   const handleDelTitles = () => {
//     setInteractionBlock({ ...interactionBlock, [`Title${seq.input}`]: null });
//   };

//   const [showLeftButton, setShowLeftButton] = useState(false);

//   const [showcount, setShowcount] = useState<any>('');

//   const handleLeft = () => {
//     const container = document.getElementById(seq.id);
//     if (container) {
//       container.scrollLeft -= 700;
//       if (container.scrollLeft <= 0) {
//         setShowLeftButton(false);
//       }
//     }
//   };

//   const handleRight = () => {
//     const container = document.getElementById(seq.id);

//     if (container) {
//       container.scrollLeft += 700;
//       setShowcount(container.scrollLeft + 300);
//       if (container.scrollLeft > 0) {
//         setShowLeftButton(true);
//       }
//     }
//   };

//   const scrollToElement = (inputId: any) => {
//     const inputElement = document.getElementById(inputId);

//     if (targetRef.current) {
//       targetRef.current.scrollIntoView({
//         behavior: 'smooth',
//         block: 'center',
//         inline: 'center',
//       });
//     }
//   };
//   // Styles for Select
//   const customStyles = {
//     menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
//     control: (provided: any, state: any) => ({
//       ...provided,
//       borderRadius: '15px',
//       borderColor: 'inherit',
//       background: 'transparent',
//       // height: '45px',
//       width: '200px',
//       padding: '0 !important',
//     }),
//   };

//   // Styles for Select QuestionEmotionStyles
//   const questionEmotionStyles = {
//     menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
//     control: (provided: any, state: any) => ({
//       ...provided,
//       borderRadius: '15px',
//       borderColor: 'inherit',
//       background: 'transparent',
//       height: '100%',
//       minHeight: '100%',
//       width: '150px',
//       padding: '0 !important',
//       border: validation?.[`QuestionsEmotion${seq.input}`] && '2px solid red',
//     }),
//   };
//   useEffect(() => {
//     if (textareaRef.current) {
//       // Adjust the height of the textarea based on its content
//       textareaRef.current.style.height = 'auto';
//       textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;

//       // Set the textarea height to adjust the marginTop of the block-score
//       setTextareaHeight(textareaRef.current.scrollHeight);
//     }
//   }, [
//     input?.[`Interaction${seq.input}`]?.interaction,
//     input?.[`Note${seq.input}`]?.note,
//   ]);

//   let focusSeqRef: any;
//   const justClick = (event: any, seq: any) => {
//     if (event.type === 'click') {
//       focusSeqRef = document.getElementsByClassName(seq.id);
//       const element = focusSeqRef?.[0];
//       if (element) {
//         element.classList.remove('non-caret');
//         element.removeAttribute('readonly');
//         element.focus();
//       }
//     }
//   };
//   const handleMiniNDInewblock = (
//     value?: any,
//     seq?: any,
//     i?: any,
//     option?: any,
//   ) => {
//     handleNDI(value);
//     const maxInputItem = items.reduce(
//       (max: any, item: any) => (item.input > max.input ? item : max),
//       items[0],
//     );
//     let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;

//     if (value != '') {
//       handleSelectBlock(
//         { value: input },
//         input,
//         option,
//         `Interaction${seq.input}`,
//       );
//     }
//   };

//   const MiniBox2 = (props: {
//     seq?: any;
//     i?: number;
//     name?: any;
//     bodyRef?: any;
//   }) => {
//     const { seq, i, name, bodyRef } = props;
//     return (
//       // <Box
//       //   position={'absolute'}
//       //   background={'#fff'}
//       //   p={'10px'}
//       //   ml={'-300px'}
//       //   boxShadow={'1px 1px 17px #69627914'}
//       //   borderRadius={'8px'}
//       //   zIndex={99}
//       //   right={{ base: '-140px', lg: '' }}
//       //   className="MiniShowBox max-h-56 overflow-y-auto"
//       // >
//        <Box
//           position={'absolute'}
//           background={'#fff'}
//           p={'10px'}
//           ml={'-300px'}
//           boxShadow={'1px 1px 17px #69627914'}
//           borderRadius={'8px'}
//           zIndex={9999}
//           right={{ base: "-140px", lg: "0" }}
//           w="200px"
//           maxH="380px"
//           overflowY="auto"
//           className="MiniShowBox"
//         >
//        <List cursor={'pointer'}>
//                 <ListItem
//                   onClick={() => handleMiniNDInewblock('Note', seq, i,name)}
//                   p={'10px'}
//                   display={'flex'}
//                   alignItems={'center'}
//                   borderBottom={'2px solid #f1f1f170'}
//                 >
//                   <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
//                   Note
//                 </ListItem>
      
//                 <ListItem
//                   onClick={() => handleMiniNDInewblock('Dialog', seq, i,name)}
//                   p={'10px'}
//                   display={'flex'}
//                   alignItems={'center'}
//                   borderBottom={'2px solid #f1f1f170'}
//                 >
//                   <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
//                   Dialog
//                 </ListItem>
//                 <ListItem
//                   onClick={() => handleMiniNDInewblock('Interaction', seq, i,name)}
//                   p={'10px'}
//                   display={'flex'}
//                   alignItems={'center'}
//                 >
//                   <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
//                   Interaction
//                 </ListItem>
//                 <ListItem
//                   onClick={() => handleMiniNDInewblock('Link', seq, i,name)}
//                   p={'10px'}
//                   display={'flex'}
//                   alignItems={'center'}
//                   borderBottom={'2px solid #f1f1f170'}
//                 >
//                   <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
//                   Link
//                 </ListItem>
//                 {showReflectionQuestions && (
//                   <>
//                     <ListItem
//                       onClick={() => handleMiniNDInewblock('Reflection', seq, i,name)}
//                       p={'10px'}
//                       display={'flex'}
//                       alignItems={'center'}
//                       borderBottom={'2px solid #f1f1f170'}
//                     >
//                       <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
//                       Reflection
//                     </ListItem>
      
//                     <ListItem
//                       onClick={() => handleMiniNDInewblock('Overview', seq, i,name)}
//                       p={'10px'}
//                       display={'flex'}
//                       alignItems={'center'}
//                       borderBottom={'2px solid #f1f1f170'}
//                     >
//                       <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
//                       Overview
//                     </ListItem>
//                     <ListItem
//                       onClick={() => handleMiniNDInewblock('KeyInsights', seq, i,name)}
//                       p={'10px'}
//                       display={'flex'}
//                       alignItems={'center'}
//                       borderBottom={'2px solid #f1f1f170'}
//                     >
//                       <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
//                       KeyInsights
//                     </ListItem>
//                     <ListItem
//                       onClick={() => handleMiniNDInewblock('PreAssessment', seq, i,name)}
//                       p={'10px'}
//                       display={'flex'}
//                       alignItems={'center'}
//                       borderBottom={'2px solid #f1f1f170'}
//                     >
//                       <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
//                       PreAssessment
//                     </ListItem>
//                     <ListItem
//                       onClick={() => handleMiniNDInewblock('PostAssessment', seq, i,name)}
//                       p={'10px'}
//                       display={'flex'}
//                       alignItems={'center'}
//                       borderBottom={'2px solid #f1f1f170'}
//                     >
//                       <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
//                       PostAssessment
//                     </ListItem>
//                      <ListItem
//                                                                                  onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
//                                                                                  p={'10px'}
//                                                                                  display={'flex'}
//                                                                                  alignItems={'center'}
//                                                                                  borderBottom={'2px solid #f1f1f170'}
//                                                                                >
//                                                                                  <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
//                                                                                  WehaveChoose
//                                                                                </ListItem>
//                                                                                           <ListItem
//                                                                                  onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
//                                                                                  p={'10px'}
//                                                                                  display={'flex'}
//                                                                                  alignItems={'center'}
//                                                                                  borderBottom={'2px solid #f1f1f170'}
//                                                                                >
//                                                                                  <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
//                                                                                  Swipe
//                                                                                </ListItem>
//                                                                                           <ListItem
//                                                                                  onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
//                                                                                  p={'10px'}
//                                                                                  display={'flex'}
//                                                                                  alignItems={'center'}
//                                                                                  borderBottom={'2px solid #f1f1f170'}
//                                                                                >
//                                                                                  <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
//                                                                                  Drag For Now 
//                                                                                </ListItem>
//                   </>
//                 )}
//                 {formData?.gameScenarioCompletion === 'true' && (
//                   <ListItem
//                     onClick={() =>
//                       handleMiniNDInewblock('ScenarioCompletion', seq, i,name)
//                     }
//                     p={'10px'}
//                     display={'flex'}
//                     alignItems={'center'}
//                     borderBottom={'2px solid #f1f1f170'}
//                   >
//                     <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
//                     ScenarioCompletion
//                   </ListItem>
//                 )}
//               </List>
//       </Box>
//     );
//   };

//   const cardRef = useRef(null);
//   useEffect(() => {
//     if (cardRef.current && seq?.id !== targetSequence?.id) {
//       cardRef.current.scrollLeft = 0;
//     }
//   }, [targetSequence, seq]);

//   return (
//     <>
//       {seq?.id === targetSequence?.id && (
//         <Box
//           className="goLeft"
//           display={'flex'}
//           alignItems={'center'}
//           height={'100%'}
//           position={'absolute'}
//           left={0}
//         >
//           <Button
//             onClick={handleLeft}
//             position={'absolute'}
//             left={0}
//             zIndex={99}
//             background={'#0000'}
//             _hover={{ background: '#0000' }}
//             boxShadow={'unset'}
//           >
//             <Icon as={MdArrowBack} color={'#fff'} />
//             <Box
//               content='""'
//               height={'30px'}
//               width={'30px'}
//               borderRadius={'30px'}
//               zIndex={-9}
//               background={'#11047a'}
//               position={'absolute'}
//             ></Box>
//           </Button>
//         </Box>
//       )}
//       {/* )}  */}
//       <Box
//         id={`${seq.id}`}
//         w={'auto'}
//         height={'100%'}
//         overflowX={seq?.id === targetSequence?.id ? 'scroll' : 'hidden'}
//         className="scroll_hide"
//         overflowY={'hidden'}
//         ref={cardRef}
//       >
//         <Box w={'max-content'} display={'flex'}>
//           <Box className="block-action-icons">
//             <Tooltip hasArrow label="Choose New Block">
//               <div>
//                 <Icon
//                   as={MdAdd}
//                   transitionDelay={'0s !important'}
//                   fontSize={'18px'}
//                   color={'grey'}
//                   mr={'10px'}
//                   cursor={'pointer'}
//                   onClick={() => getSeq(seq, index, name)}
//                 />
//               </div>
//             </Tooltip>
//             <Tooltip hasArrow label="Duplicate">
//               <div>
//                 <Icon
//                   as={BiSolidDuplicate}
//                   transitionDelay={'0.1s !important'}
//                   fontSize={'18px'}
//                   color={'grey'}
//                   mr={'10px'}
//                   cursor={'pointer'}
//                   onClick={() =>
//                     duplicateSeq(
//                       seq,
//                       index,
//                       name,
//                       input?.[`Interaction${seq.input}`],
//                     )
//                   }
//                 />
//               </div>
//             </Tooltip>
//             <Tooltip hasArrow label="Delete Interaction">
//               <div>
//                 <Icon
//                   as={MdDelete}
//                   transitionDelay={'0.2s !important'}
//                   fontSize={'18px'}
//                   color={'grey'}
//                   cursor={'pointer'}
//                   onClick={() => delSeq(seq, index, name)}
//                 />
//               </div>
//             </Tooltip>
//           </Box>
//           <Box mr={'10px'} fontWeight={'700'} w={'50px'}>
//             {seq.id}
//           </Box>
//           <Box
//             height={'100%'}
//             w={{ base: '100%', lg: 'auto' }}
//             overflow={'hidden'}
//             // padding={'5px'}
//             display={'flex'}
//             alignItems={'center'}
//           >
//             <Box mr={'10px'} w={{ base: '100%', lg: '150px' }}>
//               <Select
//                 placeholder={'Character...'}
//                 id="blockRoll"
//                 name={`Interaction${seq.input}`}
//                 menuPortalTarget={document.body}
//                 styles={{
//                   menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
//                   control: (provided: any, state: any) => ({
//                     ...provided,
//                     borderRadius: '15px',
//                     height: '40px',
//                     borderColor: 'inherit',
//                     background: 'transparent',
//                     padding: '0 !important',
//                     width: '150px',
//                   }),
//                 }}
//                 options={options}
//                 value={selectedOption}
//                 isSearchable={true}
//                 className="react-select"
//                 onChange={(selectedOption: any) => {
//                   handleBlockRoll(
//                     selectedOption,
//                     seq.input,
//                     `Interaction${seq.input}`,
//                   );
//                 }}
//               />
//             </Box>
//             <Box mr={'10px'} w={{ base: '100%', lg: '400px' }}>
//               <Textarea
//                 placeholder="Interaction - Type your Question"
//                 id="interaction"
//                 className={`${seq.id}`}
//                 name={`Interaction${seq.input}`}
//                 onChange={handleInput}
//                 onClick={(e) => justClick(e, seq)}
//                 value={
//                   language
//                     ? matchingBlockContent
//                     : input?.[`Interaction${seq.input}`]?.interaction
//                 }
//                 borderRadius={'15px'}
//                 style={{
//                   overflow: 'hidden',
//                   border:
//                     validation?.[`Interaction${seq.input}`] && '2px solid red',
//                 }}
//                 width={'400px'}
//                 minHeight="65px"
//                 height={
//                   seq?.id === targetSequence?.id ? 'auto' : '65px !important'
//                 }
//                 ref={textareaRef}
//                 _focusVisible={{
//                   borderColor: '#0000',
//                   border: '1px solid #e5e5e5',
//                   boxShadow: 'unset',
//                 }}
//                 tabIndex={0}
//                 readOnly={true}
//               />
//             </Box>
//             {parseInt(input?.[`Interaction${seq.input}`]?.blockRoll, 10) !==
//             99999 ? (
//               <Box mr={'10px'} w={{ base: '100%', lg: 'auto' }}>
//                 <Select
//                   placeholder={'Animate...'}
//                   id="interaction"
//                   name={`Interaction${seq.input}`}
//                   menuPortalTarget={document.body}
//                   styles={questionEmotionStyles}
//                   options={emotionsOptions}
//                   isClearable={false}
//                   isSearchable={true}
//                   isMulti={true}
//                   className="react-select"
//                   value={
//                     input?.[`Interaction${seq.input}`]?.QuestionsEmotion
//                       ? input?.[
//                           `Interaction${seq.input}`
//                         ]?.QuestionsEmotion.split(',').map((value: string) => ({
//                           value,
//                           label: value,
//                         }))
//                       : []
//                   }
//                   onChange={(selectedOption: any) =>
//                     handleQuestionEmotion(
//                       selectedOption,
//                       seq.input,
//                       `Interaction${seq.input}`,
//                     )
//                   }
//                 />
//               </Box>
//             ) : (
//               <Box mr={'10px'} w={'150px'}></Box>
//             )}
//               <Box
//               className="scenario-dropdown"
//               mb="10px"
//               w={{ base: '100%', lg: '200px' }}
//             >
//               <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
//                 Select Scenario
//               </Text>
            
//              <Select
//               placeholder="Select Scenario"
//               options={scenarioOptions}
//               // value={input?.[`Interaction${seq.input}`]?.scenario}
//               value={
//   scenarioOptions.find(
//     (opt) =>
//       opt.value === input?.[`Interaction${seq.input}`]?.scenario
//   ) || null
// }

//                styles={{
//                   ...customStyles,
//                   control: (provided: any) => ({
//                     ...provided,
//                     borderRadius: '12px',
//                     minHeight: '36px',
//                   }),
//                 }}
//               onChange={(option: any) =>
//                 handleInput({
//                   name: `Interaction${seq.input}`,
//                   value: {
//                     // scenario: option,
//                     scenario: option?.value,

//                   },
//                 })
//               }
//               isSearchable={false}
//               menuPortalTarget={document.body}
//             />
            
//             </Box>
//             {interactionBlock?.[`Title${[seq.input]}`] == seq.input && (
//               <Box
//                 mr={'10px'}
//                 w={'470px'}
//                 ps={'3rem'}
//                 display={'flex'}
//                 justifyContent={'center'}
//                 alignItems={'center'}
//               >
//                 <Textarea
//                   placeholder="Question Title..."
//                   name={`Interaction${seq.input}`}
//                   onChange={handleInput}
//                   value={input?.[`Interaction${[seq.input]}`].quesionTitle}
//                   id={`QuestionTitle${seq.input}`}
//                   w={'400px'}
//                   borderRadius={'15px'}
//                   style={{
//                     resize: 'none',
//                     overflowY: 'hidden',
//                     height: inputtextValue,
//                   }}
//                   _focus={{ height: '100%' }}
//                 />
//                 <Icon
//                   as={MdDelete}
//                   w={5}
//                   h={'auto'}
//                   onClick={handleDelTitles}
//                   color={'grey'}
//                 />
//               </Box>
//             )}
//             {interactionBlock?.[`Skills${[seq.input]}`] == seq.input && (
//               <Box display={'flex'} flexDir={'column'}>
//                 <Box display={'flex'}>
//                   <Textarea
//                     id={`skills`}
//                     placeholder="Skills..."
//                     name={`Interaction${seq.input}`}
//                     w={'160px'}
//                     // m={'0px 0 15px 10px'}
//                     minHeight="40px"
//                     borderRadius={'18px'}
//                     onChange={handleInput}
//                     value={input?.[`Interaction${seq.input}`]?.SkillTag}
//                   />
//                   <Box
//                     m={'10px 0 0px -30px'}
//                     w={'100px'}
//                     textAlign={'center'}
//                     cursor={'pointer'}
//                     onClick={handleDelSkills}
//                   >
//                     <Icon w={5} height={'auto'} as={MdDelete} color={'grey'} />
//                   </Box>
//                 </Box>
//               </Box>
//             )}
//             <Box className="block-btns">
//               <Box display={'flex'} flexDir={'column'}>
//                 <Flex flexDir={{ base: 'column', sm: 'row' }}>
//                   {interactionBlock?.[`Resp${seq.input}`] !== seq?.input ? (
//                     <Button
//                       mr={'10px'}
//                       w={'130px'}
//                       p={5}
//                       justifyContent={'start'}
//                       onClick={() =>
//                         setInteractionBlock((prev: any) => {
//                           return { ...prev, [`Resp${[seq.input]}`]: seq.input };
//                         })
//                       }
//                     >
//                       <Icon
//                         as={MdAdd}
//                         bg={'blue'}
//                         color={'#fff'}
//                         borderRadius={'888px'}
//                         mr={'5px'}
//                       />{' '}
//                       <Text>Response</Text>
//                     </Button>
//                   ) : null}
//                   {interactionBlock?.[`Feedbk${seq.input}`] !== seq?.input ? (
//                     <Button
//                       mr={'10px'}
//                       w={'130px'}
//                       p={5}
//                       justifyContent={'start'}
//                       onClick={() =>
//                         setInteractionBlock((prev: any) => {
//                           return {
//                             ...prev,
//                             [`Feedbk${[seq.input]}`]: seq.input,
//                           };
//                         })
//                       }
//                     >
//                       <Icon
//                         as={MdAdd}
//                         bg={'blue'}
//                         color={'#fff'}
//                         borderRadius={'888px'}
//                         mr={'5px'}
//                       />{' '}
//                       <Text>Feedback</Text>
//                     </Button>
//                   ) : null}
//                   {interactionBlock?.[`Title${seq.input}`] !== seq?.input ? (
//                     <Button
//                       mr={'10px'}
//                       w={'130px'}
//                       p={5}
//                       justifyContent={'start'}
//                       onClick={() => {
//                         setInteractionBlock((prev: any) => {
//                           return {
//                             ...prev,
//                             [`Title${[seq.input]}`]: seq.input,
//                           };
//                         });
//                         scrollToElement(`QuestionTitle${seq.input}`);
//                       }}
//                     >
//                       <Icon
//                         as={MdAdd}
//                         bg={'blue'}
//                         color={'#fff'}
//                         borderRadius={'888px'}
//                         mr={'5px'}
//                       />{' '}
//                       <Text>Title</Text>
//                     </Button>
//                   ) : null}
//                   {interactionBlock?.[`Skills${seq.input}`] !== seq?.input ? (
//                     <Button
//                       mr={'10px'}
//                       w={'130px'}
//                       p={5}
//                       justifyContent={'start'}
//                       onClick={() => {
//                         setInteractionBlock((prev: any) => {
//                           return {
//                             ...prev,
//                             [`Skills${[seq.input]}`]: seq.input,
//                           };
//                         });
//                         scrollToElement(`skill${seq.input}`);
//                       }}
//                     >
//                       <Icon
//                         as={MdAdd}
//                         bg={'blue'}
//                         color={'#fff'}
//                         borderRadius={'888px'}
//                         mr={'5px'}
//                       />{' '}
//                       <Text>Skills</Text>
//                     </Button>
//                   ) : null}
//                 </Flex>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//         {seq?.id === targetSequence?.id && (
//           <Box w={'auto'} h={'100%'} display={'flex'}>
//             <Box className="options_interaction" ml={'227px'}>
//               <TableContainer>
//                 <Table variant="unStyled">
//                   <Thead>
//                     <Tr>
//                       <Th textAlign={'center'}></Th>
//                       {interactionBlock?.[`Title${[seq.input]}`] ==
//                         seq.input && <Th textAlign={'center'}>Title</Th>}
//                       {interactionBlock?.[`Resp${[seq.input]}`] ===
//                         seq?.input && <Th textAlign={'center'}></Th>}
//                       {interactionBlock?.[`Resp${[seq.input]}`] ===
//                         seq?.input && (
//                         <Th
//                           display="flex"
//                           alignItems="center"
//                           justifyContent={'center'}
//                         >
//                           Response
//                           <Tooltip label="Delete Response" hasArrow>
//                             <div>
//                               <Icon
//                                 as={MdDelete}
//                                 w={5}
//                                 h={'auto'}
//                                 onClick={handleDelResponse}
//                                 cursor={'pointer'}
//                                 color={'grey'}
//                               />
//                             </div>
//                           </Tooltip>
//                         </Th>
//                       )}
//                       {interactionBlock?.[`Feedbk${[seq.input]}`] ===
//                         seq.input && (
//                         <Th>
//                           <Box
//                             w={'100%'}
//                             display={'flex'}
//                             justifyContent={'center'}
//                             alignItems={'center'}
//                           >
//                             FeedBack
//                             <Tooltip label="Delete Feedback" hasArrow>
//                               <div>
//                                 <Icon
//                                   as={MdDelete}
//                                   w={5}
//                                   h={'auto'}
//                                   onClick={handleDelFeedback}
//                                   cursor={'pointer'}
//                                   color={'grey'}
//                                 />
//                               </div>
//                             </Tooltip>
//                           </Box>
//                         </Th>
//                       )}
//                       <Th textAlign={'center'}>Right</Th>
//                       <Th textAlign={'center'}>Score</Th>
//                       <Th textAlign={'center'}>Navigation</Th>
//                     </Tr>
//                   </Thead>
//                   <Tbody>
//                     {alphabet
//                       ?.filter((alp: any) => alp.seqs === seq.id)
//                       .map((alp: any, i: number, arr: any[]) => {
//                         const isLastElement = i === arr.length - 1;
//                         const iconId = `deleteIcon_${alp.option}`;
//                         return (
//                           <Tr>
//                             <Td textAlign={'center'}>
//                               <Box
//                                 className="interaction-option"
//                                 display={'flex'}
//                                 alignItems={'center'}
//                                 mb={'10px'}
//                               >
//                                 <Box
//                                   className="interaction-option-del-icon"
//                                   ml={'-17px'}
//                                   mr={'4px'}
//                                   cursor={'pointer'}
//                                   onClick={() =>
//                                     deleteAndRearrange(alp.seqs, alp.option)
//                                   }
//                                 >
//                                   <Icon as={MdDelete} color={'grey'} />
//                                 </Box>
//                                 <Box
//                                   key={alp.option}
//                                   position={'relative'}
//                                   display={'flex'}
//                                   alignItems={'center'}
//                                 >
//                                   <Textarea
//                                     placeholder={`Option${alp.option}`}
//                                     id={`Option${alp.option}`}
//                                     name={`Interaction${seq.input}`}
//                                     onChange={handleInput}
//                                     pl={'25px'}
//                                     onClick={handleInter}
//                                     onKeyDown={handleKeyDown}
//                                     onBlur={(e: any) => {
//                                       handleFocusOut();
//                                       // blockOnBlurHanlder(e, seq);
//                                     }}
//                                     // onFocus={(e:any) => blockOnFocusHanlder(e,seq)}
//                                     borderRadius={'15px'}
//                                     border={
//                                       validation?.[
//                                         `options${seq.input}${alp.option}`
//                                       ]
//                                         ? '2px solid red'
//                                         : '1px solid #e5e5e5'
//                                     }
//                                     title={alp.option}
//                                     value={
//                                       language
//                                         ? (filteredOptions &&
//                                             filteredOptions.find(
//                                               (option: Option) =>
//                                                 option.qpOptions === alp.option,
//                                             )?.contentOptionTextData[0]
//                                               ?.content) ||
//                                           ''
//                                         : input?.[`Interaction${seq.input}`]
//                                             ?.optionsObject?.[alp.option]
//                                     }
//                                     w={'400px'}
//                                     mr={'10px'}
//                                     style={{
//                                       resize: 'none',
//                                       overflowY: 'hidden',
//                                       height: 'auto',
//                                       border: validation?.[
//                                         `options${seq.input}${alp.option}`
//                                       ]
//                                         ? '2px solid red'
//                                         : '1px solid #e5e5e5',
//                                     }}
//                                     _focus={{ height: '100%' }}
//                                   />
//                                   <Box>
//                                     <Text
//                                       position={'absolute'}
//                                       top={'13px'}
//                                       left={'5px'}
//                                       display={'flex'}
//                                       justifyContent={'center'}
//                                       alignItems={'center'}
//                                       h={'11px'}
//                                       w={'11px'}
//                                       bg={'#000'}
//                                       color={'#fff'}
//                                       p={'7px'}
//                                       borderRadius={'30px'}
//                                       fontSize={'10px'}
//                                     >
//                                       {alp.option}
//                                     </Text>
//                                   </Box>

//                                   <Box mr={'10px'}>
//                                     <Select
//                                       placeholder={'Animate...'}
//                                       id={`Option${alp.option}`}
//                                       name={`Interaction${seq.input}`}
//                                       menuPortalTarget={document.body}
//                                       styles={{
//                                         menuPortal: (base: any) => ({
//                                           ...base,
//                                           zIndex: 9999,
//                                         }),
//                                         control: (
//                                           provided: any,
//                                           state: any,
//                                         ) => ({
//                                           ...provided,
//                                           borderRadius: '15px',
//                                           borderColor: 'inherit',
//                                           background: 'transparent',
//                                           width: '200px',
//                                           padding: '0 !important',
//                                           border:
//                                             validation?.[
//                                               `optionsEmotion${seq.input}${alp.option}`
//                                             ] && '2px solid red',
//                                         }),
//                                       }}
//                                       options={emotionsOptions}
//                                       isSearchable={true}
//                                       isClearable={false}
//                                       className="react-select"
//                                       isMulti={true}
//                                       value={
//                                         input?.[`Interaction${seq.input}`]
//                                           ?.optionsemotionObject?.[alp.option]
//                                           ? input?.[
//                                               `Interaction${seq.input}`
//                                             ]?.optionsemotionObject?.[
//                                               alp.option
//                                             ]
//                                               .split(',')
//                                               .map((value: string) => ({
//                                                 value,
//                                                 label: value,
//                                               }))
//                                           : []
//                                       }
//                                       onChange={(e: any) =>
//                                         handleOptionEmotion(
//                                           e,
//                                           seq.input,
//                                           `Option${alp.option}`,
//                                           `Interaction${seq.input}`,
//                                         )
//                                       }
//                                     />
//                                   </Box>
//                                 </Box>
//                               </Box>
//                             </Td>
//                             {interactionBlock?.[`Title${[seq.input]}`] ==
//                               seq.input && (
//                               <Td>
//                                 <Box mr={'10px'}>
//                                   <Box>
//                                     <Textarea
//                                       placeholder={`Title${alp.option}`}
//                                       id={`OptionTitle${alp.option}`}
//                                       name={`Interaction${seq.input}`}
//                                       onChange={handleInput}
//                                       onKeyDown={handleKeyDown}
//                                       onBlur={handleFocusOut}
//                                       title={alp.option}
//                                       value={
//                                         input?.[`Interaction${seq.input}`]
//                                           ?.optionTitleObject?.[alp.option]
//                                       }
//                                       pl={'25px'}
//                                       mb={'10px'}
//                                       borderRadius={'15px'}
//                                       w={'400px'}
//                                       style={{
//                                         resize: 'none',
//                                         overflowY: 'hidden',
//                                         height: inputtextValue,
//                                       }}
//                                     />
//                                   </Box>
//                                 </Box>
//                               </Td>
//                             )}
//                             {interactionBlock?.[`Resp${[seq.input]}`] ===
//                               seq?.input &&
//                               i === 0 && (
//                                 <Td rowSpan={arr?.length}>
//                                   <Select
//                                     placeholder={'Character...'}
//                                     id="ResponseCharter"
//                                     name={`Interaction${seq.input}`}
//                                     menuPortalTarget={document.body}
//                                     styles={{
//                                       menuPortal: (base: any) => ({
//                                         ...base,
//                                         zIndex: 9999,
//                                       }),
//                                       control: (provided: any, state: any) => ({
//                                         ...provided,
//                                         borderRadius: '15px',
//                                         height: '40px',
//                                         borderColor: 'inherit',
//                                         background: 'transparent',
//                                         padding: '0 !important',
//                                         width: '115px',
//                                         marginLeft: '4px',
//                                       }),
//                                     }}
//                                     options={options}
//                                     value={selectedrespoOption}
//                                     isSearchable={true}
//                                     className="react-select"
//                                     onChange={(selectedOption: any) =>
//                                       handleResponseRoll(
//                                         selectedOption,
//                                         seq.input,
//                                         `Interaction${seq.input}`,
//                                       )
//                                     }
//                                   />
//                                 </Td>
//                               )}
//                             {interactionBlock?.[`Resp${[seq.input]}`] ===
//                               seq?.input && (
//                               <Td textAlign={'center'}>
//                                 <Box
//                                   key={i}
//                                   position={'relative'}
//                                   display={'flex'}
//                                   alignItems={'center'}
//                                   mb={'10px'}
//                                 >
//                                   <Box mr={'10px'}>
//                                     <Textarea
//                                       placeholder={'Response'}
//                                       id={`Response${alp.option}`}
//                                       title={alp.option}
//                                       name={`Interaction${seq.input}`}
//                                       onChange={handleInput}
//                                       onClick={handleInter}
//                                       pl={'25px'}
//                                       borderRadius={'15px'}
//                                       value={
//                                         language
//                                           ? (ResponseOptions &&
//                                               ResponseOptions.find(
//                                                 (option: Option) =>
//                                                   option.qpOptions ===
//                                                   alp.option,
//                                               )?.contentOptionTextData[0]
//                                                 ?.content) ||
//                                             ''
//                                           : input?.[`Interaction${seq.input}`]
//                                               ?.responseObject?.[alp.option]
//                                       }
//                                       w={'200px'}
//                                       style={{
//                                         resize: 'none',
//                                         overflowY: 'hidden',
//                                         height: inputtextValue,
//                                       }}
//                                     />
//                                     <Text
//                                       position={'absolute'}
//                                       top={'13px'}
//                                       left={'5px'}
//                                       display={'flex'}
//                                       justifyContent={'center'}
//                                       alignItems={'center'}
//                                       h={'11px'}
//                                       w={'11px'}
//                                       bg={'#000'}
//                                       color={'#fff'}
//                                       p={'7px'}
//                                       borderRadius={'30px'}
//                                       fontSize={'10px'}
//                                     >
//                                       {alp.option}
//                                     </Text>
//                                   </Box>
//                                   {input?.[`Interaction${seq.input}`]
//                                     ?.responseRoll !== 99999 &&
//                                     input?.[`Interaction${seq.input}`]
//                                       ?.responseRoll !== '99999' && (
//                                       <Box>
//                                         <Select
//                                           placeholder={'Animate...'}
//                                           id={`Option${alp.option}`}
//                                           name={`Interaction${seq.input}`}
//                                           menuPortalTarget={document.body}
//                                           styles={customStyles}
//                                           options={emotionsOptions}
//                                           isSearchable={true}
//                                           isClearable={false}
//                                           isMulti={true}
//                                           className="react-select"
//                                           value={
//                                             input?.[`Interaction${seq.input}`]
//                                               ?.responseemotionObject?.[
//                                               alp.option
//                                             ]
//                                               ? input?.[
//                                                   `Interaction${seq.input}`
//                                                 ]?.responseemotionObject?.[
//                                                   alp.option
//                                                 ]
//                                                   .split(',')
//                                                   .map((value: string) => ({
//                                                     value,
//                                                     label: value,
//                                                   }))
//                                               : []
//                                           }
//                                           onChange={(e: any) =>
//                                             handleResponseEmotion(
//                                               e,
//                                               seq.input,
//                                               `Option${alp.option}`,
//                                               `Interaction${seq.input}`,
//                                             )
//                                           }
//                                         />
//                                       </Box>
//                                     )}
//                                 </Box>
//                               </Td>
//                             )}
//                             {interactionBlock?.[`Feedbk${[seq.input]}`] ===
//                               seq.input && (
//                               <Td textAlign={'center'}>
//                                 <Box display={'flex'} mb={'10px'}>
//                                   <Box
//                                     key={i}
//                                     position={'relative'}
//                                     display={'flex'}
//                                   >
//                                     <Textarea
//                                       placeholder={'Feedback'}
//                                       id={`FeedBack${alp.option}`}
//                                       title={alp.option}
//                                       name={`Interaction${seq.input}`}
//                                       onChange={handleInput}
//                                       onClick={handleInter}
//                                       pl={'25px'}
//                                       borderRadius={'15px'}
//                                       value={
//                                         input?.[`Interaction${seq.input}`]
//                                           ?.feedbackObject?.[alp.option]
//                                       }
//                                       mb={'3px'}
//                                       w={'200px'}
//                                       style={{
//                                         resize: 'none',
//                                         overflowY: 'hidden',
//                                         height: inputtextValue,
//                                       }}
//                                     />
//                                     <Text
//                                       position={'absolute'}
//                                       top={'13px'}
//                                       left={'5px'}
//                                       display={'flex'}
//                                       justifyContent={'center'}
//                                       alignItems={'center'}
//                                       h={'11px'}
//                                       w={'11px'}
//                                       bg={'#000'}
//                                       color={'#fff'}
//                                       p={'7px'}
//                                       borderRadius={'30px'}
//                                       fontSize={'10px'}
//                                     >
//                                       {alp.option}
//                                     </Text>
//                                   </Box>
//                                 </Box>
//                               </Td>
//                             )}
//                             <Td textAlign={'center'}>
//                               <Box>
//                                 <Checkbox
//                                   size="md"
//                                   border={
//                                     validation?.[`checkbox${seq.input}`] &&
//                                     '2px solid red'
//                                   }
//                                   colorScheme="green"
//                                   id={`Ans${alp.option}`}
//                                   title={alp.option}
//                                   name={`Interaction${seq.input}`}
//                                   onChange={(e: any) =>
//                                     handleCheckBox(
//                                       e,
//                                       seq.input,
//                                       `Option${alp.option}`,
//                                       `Interaction${seq.input}`,
//                                     )
//                                   }
//                                   isChecked={
//                                     input?.[`Interaction${seq.input}`]
//                                       ?.ansObject?.[alp.option] === true ||
//                                     input?.[`Interaction${seq.input}`]
//                                       ?.ansObject?.[alp.option] === 'true'
//                                   }
//                                 ></Checkbox>
//                               </Box>
//                             </Td>
//                             <Td textAlign={'center'} p={0}>
//                               <Box>
//                                 <Input
//                                   type="text"
//                                   borderRadius={'15px'}
//                                   border={
//                                     validation?.[`score${seq.input}`] &&
//                                     '2px solid red'
//                                   }
//                                   placeholder="00"
//                                   id={`Score${alp.option}`}
//                                   title={alp.option}
//                                   name={`Interaction${seq.input}`}
//                                   onChange={handleInput}
//                                   onKeyPress={(e) => {
//                                     const allowedKeys = [
//                                       '0',
//                                       '1',
//                                       '2',
//                                       '3',
//                                       '4',
//                                       '5',
//                                       '6',
//                                       '7',
//                                       '8',
//                                       '9',
//                                       'Backspace',
//                                       'Delete',
//                                       'ArrowLeft',
//                                       'ArrowRight',
//                                       'Tab',
//                                     ];

//                                     if (!allowedKeys.includes(e.key)) {
//                                       e.preventDefault();
//                                     }
//                                   }}
//                                   autoComplete="off"
//                                   value={
//                                     input?.[`Interaction${seq.input}`]
//                                       ?.scoreObject?.[alp.option]
//                                   }
//                                   style={{ height: '30px' }}
//                                 />
//                                 <span hidden>{alp.option}</span>
//                               </Box>
//                             </Td>
//                             <Td textAlign={'center'}>
//                               <Box style={{ marginBottom: '-20px' }}>
//                                 <Flex mb={'13px'}>
//                                   <Box>
//                                     <Tooltip hasArrow label="Add Navigations">
//                                       <div>
//                                         <Menu
//                                           tabState={'navigation'}
//                                           option={`Option${alp.option}`}
//                                           id={seq.input}
//                                           for={`Interaction${seq.input}`}
//                                           setNavigation={setNavigation}
//                                           handleBlock={handleBlock}
//                                           items={items}
//                                           seq={seq}
//                                         />
//                                       </div>
//                                     </Tooltip>
//                                   </Box>

//                                   <Box
//                                     ml={'4px'}
//                                     cursor={'pointer'}
//                                     display={
//                                       input?.[`Interaction${seq.input}`]
//                                         ?.navigateshowObjects?.[alp.option]
//                                         ? 'block'
//                                         : 'none'
//                                     }
//                                     position={'relative'}
//                                   >
//                                     {input?.[`Interaction${seq.input}`]
//                                       ?.navigateshowObjects?.[alp.option] ===
//                                       'New Block' &&
//                                     !input?.[`Interaction${seq.input}`]
//                                       ?.navigateObjects?.[alp.option] ? (
//                                       <>
//                                         <MiniBox2
//                                           seq={seq}
//                                           i={index}
//                                           name={`Option${alp.option}`}
//                                         />
//                                       </>
//                                     ) : input?.[`Interaction${seq.input}`]
//                                         ?.navigateshowObjects?.[alp.option] ===
//                                         'Select Block' &&
//                                       !input?.[`Interaction${seq.input}`]
//                                         ?.navigateObjects?.[alp.option] ? (
//                                       <Select
//                                         placeholder={'Blocks...'}
//                                         id="interaction"
//                                         name={`Interaction${seq.input}`}
//                                         menuPortalTarget={document.body}
//                                         styles={customStyles}
//                                         options={showSelectBlock.filter(
//                                           (option: any) =>
//                                             option.value !== seq.input,
//                                         )}
//                                         isSearchable={true}
//                                         className="react-select"
//                                         value={
//                                           showSelectBlock.find(
//                                             (option: any) =>
//                                               option.value ==
//                                               input?.[`Interaction${seq.input}`]
//                                                 ?.navigateObjects?.[alp.option],
//                                           ) || null
//                                         }
//                                         onChange={(e: any) =>
//                                           handleSelectBlock(
//                                             e,
//                                             seq.input,
//                                             `Option${alp.option}`,
//                                             `Interaction${seq.input}`,
//                                           )
//                                         }
//                                       />
//                                     ) : (
//                                       <>
//                                         <div
//                                           style={{
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             width: '164px',
//                                           }}
//                                         >
//                                           <StrightConector
//                                             name={
//                                               input?.[`Interaction${seq.input}`]
//                                                 ?.navigateshowObjects?.[
//                                                 alp.option
//                                               ] === 'New Block'
//                                                 ? showSelectBlock.find(
//                                                     (option: any) =>
//                                                       option.value ==
//                                                       input?.[
//                                                         `Interaction${seq.input}`
//                                                       ]?.navigateObjects?.[
//                                                         alp.option
//                                                       ],
//                                                   )?.label
//                                                 : input?.[
//                                                     `Interaction${seq.input}`
//                                                   ]?.navigateshowObjects?.[
//                                                     alp.option
//                                                   ] === 'Select Block'
//                                                 ? showSelectBlock.find(
//                                                     (option: any) =>
//                                                       option.value ==
//                                                       input?.[
//                                                         `Interaction${seq.input}`
//                                                       ]?.navigateObjects?.[
//                                                         alp.option
//                                                       ],
//                                                   )?.label
//                                                 : input?.[
//                                                     `Interaction${seq.input}`
//                                                   ]?.navigateObjects?.[
//                                                     alp.option
//                                                   ]
//                                             }
//                                           />
//                                         </div>
//                                       </>
//                                     )}
//                                   </Box>
//                                 </Flex>
//                               </Box>
//                             </Td>
//                           </Tr>
//                         );
//                       })}
//                     <Tr>
//                       <Td>
//                         <Box
//                           position={'relative'}
//                           opacity={0.6}
//                           cursor={'pointer'}
//                           onClick={(e) => {
//                             const currentOptions = alphabet?.filter(
//                               (alp: any) => alp.seqs === seq.id,
//                             );
//                             if (currentOptions.length >= 5) {
//                               toast({
//                                 title: 'Limit Reached',
//                                 description: 'Only 5 options can be created.',
//                                 status: 'error',
//                                 duration: 3000,
//                                 isClosable: true,
//                               });
//                               return;
//                             }
//                             handleSubmit(e);
//                           }}
//                           display={'flex'}
//                         >
//                           <Box visibility={'hidden'} w={'20px'}>
//                             <Icon as={MdDelete} />
//                           </Box>
//                           <Input
//                             placeholder={'Add Option'}
//                             name={alphabet}
//                             pl={'25px'}
//                             borderRadius={'10px'}
//                             tabIndex={1}
//                             style={{ pointerEvents: 'none' }}
//                             w={'240px'}
//                           />
//                           <Text
//                             position={'absolute'}
//                             top={'13px'}
//                             left={'25px'}
//                             display={'flex'}
//                             justifyContent={'center'}
//                             alignItems={'center'}
//                             h={'11px'}
//                             w={'11px'}
//                             bg={'#000'}
//                             color={'#fff'}
//                             p={'7px'}
//                             borderRadius={'30px'}
//                             fontSize={'10px'}
//                           ></Text>
//                         </Box>
//                       </Td>
//                     </Tr>
//                   </Tbody>
//                 </Table>
//               </TableContainer>
//             </Box>
//           </Box>
//         )}
//       </Box>
//       {seq?.id === targetSequence?.id && (
//         <Box
//           className="goRight"
//           display={'flex'}
//           alignItems={'center'}
//           height={'100%'}
//           position={'absolute'}
//           right={0}
//         >
//           <Button
//             onClick={handleRight}
//             position={'absolute'}
//             right={0}
//             zIndex={999}
//             background={'#0000'}
//             _hover={{ background: '#0000' }}
//             boxShadow={'unset'}
//           >
//             <Icon as={MdArrowForward} color={'#fff'} />
//             <Box
//               content='""'
//               height={'30px'}
//               width={'30px'}
//               borderRadius={'30px'}
//               zIndex={-9}
//               background={'#11047a'}
//               position={'absolute'}
//             ></Box>
//           </Button>
//         </Box>
//       )}
//     </>
//   );
// };

// export default InteractionCompo;


//sundar
import React, { useEffect, useRef, useState } from 'react';
import { HiLink } from 'react-icons/hi';
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import { FaLightbulb } from "react-icons/fa";
import { FaChartLine  } from 'react-icons/fa';
import { FaClipboardList  } from 'react-icons/fa';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import {
  Box,
  Text,
  Flex,
  Button,
  Icon,
  List,
  ListItem,
  Input,
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
  Th,
  TableContainer,
  Checkbox,
  Textarea,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import Select, { GroupBase, OptionsOrGroups } from 'react-select';
import {
  MdAdd,
  MdArrowBack,
  MdArrowForward,
  MdOutlineStickyNote2,
  MdDelete,
} from 'react-icons/md';

import { BiSolidDuplicate } from 'react-icons/bi';

import Menu from '../components/Navigate';

import { TbHandClick, TbMessages } from 'react-icons/tb';
import StrightConector from '../components/dragNdrop/strightConector';
import { FaAward } from 'react-icons/fa6';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";
interface PropsInteraction {
  targetSequence?: any;
  reviews?: any;
  id?: number;
  language?: any;
  seq?: any;
  index?: number;
  name?: any;
  number?: any;
  handleNDI?: any;
  dummySequence?: any;
  getSeq?: any;
  duplicateSeq?: any;
  delSeq?: any;
  input?: any;
  handleInput?: any;
  handleSelect?: any;
  characterOption?: any;
  alphabet?: any;
  setAlphabet?: any;
  animateBtn?: any;
  setAnimateBtn?: any;
  interactionBlock?: any;
  setInteractionBlock?: any;
  formData?: any;
  handleBlockRoll: any;
  handleResponseRoll: any;
  handleQuestionEmotion: any;
  handleOptionEmotion: any;
  handleResponseEmotion: any;
  handleCheckBox: any;
  inputtextValue: any;
  setNavigation: any;
  handleBlock: any;
  handleOptionVoice: any;
  handleQuestionVoice: any;
  countalphabet: any;
  setAlphabetCount: any;
  items: any;
  handleSelectBlock: any;
  handleTagsChange: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  validation?: any;
  handleMiniNDI?: any;
  currentseq?: any;
  ShowReview?: any;
  blockOnFocusHanlder: any;
  blockOnBlurHanlder: any;
  showReflectionQuestions:any;
}
const customButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  borderRadius: '15px',
  borderColor: '#ccc', // Optional: Change border color for disabled state
  borderWidth: '1px', // Add this line to set the border width
  borderStyle: 'solid', // Add this line to set the border style
  cursor: 'not-allowed', // Optional: Change cursor for disabled state
  padding: '5px 10px',
  width: '144px',
  // textAlign: "left",
  outerWidth: '10px',
  outline: 'none',
};
interface Option {
  qpOptionId: number;
  qpSequence: string;
  qpQuestNo: number;
  qpOptions: string;
  qpResponse: string;
  contentOptionTextData: { textId: number; content: string }[];
}

const InteractionCompo: React.FC<PropsInteraction> = ({
  targetSequence,
showReflectionQuestions,
  language,
  seq,
  index,
  number,
  dummySequence,
  name,
  handleInput,

  input,
  getSeq,
  duplicateSeq,
  delSeq,

  alphabet,
  setAlphabet,

  interactionBlock,
  setInteractionBlock,
  formData,
  handleBlockRoll,
  handleQuestionEmotion,
  handleOptionEmotion,
  handleResponseEmotion,
  handleCheckBox,
  setNavigation,
  handleBlock,
  inputtextValue,

  countalphabet,
  setAlphabetCount,
  items,
  handleSelectBlock,
  handleResponseRoll,
  handleNDI,

  showSelectBlock,

  validation,
}) => {
  const initial = {
    [`block${index}`]: [''],
  };
  const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
  label: `Scenario ${i + 1}`,
  value: `Scenario ${i + 1}`,
}));
  const toast = useToast();
  const textareaRef = useRef(null);
  const targetRef = useRef(null);
  const [textareaHeight, setTextareaHeight] = useState<number>(0);
  const [keyUp, setKeyUp] = useState<any>(),
    [upComing, setUpComing] = useState<any>([]),
    [showAlpha, setShowAlpha] = useState<any>(['A']),
    [state, setState] = useState<any>(initial);

  const [matchingBlockContent, setMatchingBlockContent] = useState('');
  const [filteredOptions, setFilteredOptions] = useState<Option[] | null>(null);
  const [ResponseOptions, setResponseOptions] = useState<Option[] | null>(null);

  useEffect(() => {
    const blocks: any = [];
    dummySequence.forEach((item: any) => {
      blocks[item] = [''];
    });

    setState({ ...state, blocks });
  }, [number]);


   const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);



  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const secondarycount = countalphabet + 1;
    setAlphabetCount(secondarycount);
    const lastElement = alphabet
      .filter((item: any) => item.seqs === seq.id)
      .reduce(
        (acc: any, cur: any) => (cur.option > acc.option ? cur : acc),
        alphabet[0],
      );

    const currentAlpha = lastElement.option;
    const currentLetter = currentAlpha.charAt(currentAlpha.length - 1);
    let nextLetter = '';
    let upComingAlpha = '';
    if (currentLetter.charCodeAt(0) >= 90) {
      nextLetter = 'A';
      upComingAlpha = 'A';
    } else {
      nextLetter = String.fromCharCode(currentLetter.charCodeAt(0) + 1);
      upComingAlpha = String.fromCharCode(nextLetter.charCodeAt(0) + 1);
    }
    const newAlpha = [
      ...alphabet,
      { seq: seq.id, option: `${currentAlpha}${nextLetter}` },
    ];

    setAlphabet((prev: any) => [
      ...prev,
      { seqs: seq.id, option: nextLetter, secondaryId: secondarycount },
    ]);
    setUpComing(upComingAlpha);

    setShowAlpha([...showAlpha, nextLetter]);

    if (nextLetter > 'Z') {
    }
  };

  const handleKeyDown = (e: any) => {
    setKeyUp(true);
  };
  const handleInter = (e: any) => {
    const textarea = e.target;
    textarea.style.height = `${textarea.scrollHeight}px`;
  };
  const handleFocusOut = () => {
    setKeyUp(false);
  };

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedrespoOption, setSelectedrespoOption] = useState(null);
  useEffect(() => {
    const newOptions = [
      { value: 99999, altValue: 'Narrator', label: 'Narrator' },
       { value: 9999, label: 'Mentor' },
      // {
      //   value: formData.gameNonPlayingCharacterId,
      //   label: formData.gameNonPlayerName,
      // },
      ...(Array.isArray(formData?.gameNonPlayerOption)
  ? formData.gameNonPlayerOption.map((npc: any) => ({
      value: npc.gasId,
      label: npc.name,
    }))
  : []),
    ];

    setOptions(newOptions);
  }, [formData.gameNonPlayingCharacterId, formData.gameNonPlayerName]);

  useEffect(() => {
    const initialOption =
      options.find((option) => {
        const blockRoll = input?.[`Interaction${seq.input}`]?.blockRoll;

        // Numeric comparison
        if (!isNaN(blockRoll) && !isNaN(parseInt(blockRoll, 10))) {
          return option.value === parseInt(blockRoll, 10);
        }
        // String comparison for altValue
        else if (option.altValue === blockRoll) {
          return true;
        }
        // Fallback to label comparison
        else {
          return option.label === formData.gameNonPlayerName;
        }
      }) || null;

    const respoOption =
      options.find((option) => {
        const responseRoll = input?.[`Interaction${seq.input}`]?.responseRoll;

        // Numeric comparison
        if (!isNaN(responseRoll) && !isNaN(parseInt(responseRoll, 10))) {
          return option.value === parseInt(responseRoll, 10);
        }
        // String comparison for altValue
        else if (option.altValue === responseRoll) {
          return true;
        }
        // Fallback to label comparison
        else {
          return option.label === formData.gameNonPlayerName;
        }
      }) || null;
    setSelectedOption(initialOption);
    setSelectedrespoOption(respoOption);
  }, [options, seq.input, input]);

  const emotionsOptions = [
    { value: 'Talking', label: 'Talking', key: 1 },
    { value: 'Asking', label: 'Asking', key: 2 },
    { value: 'Agreeing', label: 'Agreeing', key: 3 },
    { value: 'Saying no', label: 'Saying no', key: 4 },
    { value: 'Happy', label: 'Happy', key: 5 },
    { value: 'Disappointed', label: 'Disappointed', key: 6 },
    { value: 'Angry', label: 'Angry', key: 7 },
    { value: 'Talking02', label: 'Talking02', key: 9 },
    { value: 'Idle', label: 'Idle', key: 8 },
    { value: 'walk2', label: 'Walk', key: 10 }
  ];

  const deleteAndRearrange = (seqs: string, option: string) => {
    // Filter out the deleted element

    if (typeof input === 'object' && input !== null) {
      // Find the iteration with the specified key
      const iteration = input[`Interaction${seq.input}`];

      if (iteration) {
        // Ensure that optionsObject is an object
        if (
          typeof iteration.optionsObject === 'object' &&
          iteration.optionsObject !== null
        ) {
          // Delete the specified optionKey from optionsObject
          delete iteration?.optionsObject[option];
          delete iteration?.ansObject[option];

          if (
            iteration.ansObject &&
            iteration.ansObject.hasOwnProperty(option)
          ) {
            delete iteration?.ansObject[option];
          }

          if (
            iteration.feedbackObject &&
            iteration.feedbackObject.hasOwnProperty(option)
          ) {
            delete iteration?.feedbackObject[option];
          }
          if (
            iteration.checklistObject &&
            iteration.checklistObject.hasOwnProperty(option)
          ) {
            delete iteration?.checklistObject[option];
          }

          if (
            iteration.responseObject &&
            iteration.responseObject.hasOwnProperty(option)
          ) {
            delete iteration?.responseObject[option];
          }
          if (
            iteration.responseObject &&
            iteration.responseObject.hasOwnProperty(option)
          ) {
            delete iteration?.responseObject[option];
          }

          if (
            iteration.scoreObject &&
            iteration.scoreObject.hasOwnProperty(option)
          ) {
            delete iteration?.scoreObject[option];
          }

          if (
            iteration.optionsemotionObject &&
            iteration.optionsemotionObject.hasOwnProperty(option)
          ) {
            delete iteration?.optionsemotionObject[option];
          }

          if (
            iteration.responseemotionObject &&
            iteration.responseemotionObject.hasOwnProperty(option)
          ) {
            delete iteration?.responseemotionObject[option];
          }

          if (
            iteration.optionTitleObject &&
            iteration.optionTitleObject.hasOwnProperty(option)
          ) {
            delete iteration?.optionTitleObject[option];
          }

          if (
            iteration.optionsvoiceObject &&
            iteration.optionsvoiceObject.hasOwnProperty(option)
          ) {
            delete iteration.optionsvoiceObject[option];
          }

          // Get the remaining keys and sort them alphabetically
          const remainingKeys = Object.keys(iteration.optionsObject).sort();

          // Create a new optionsObject with the reordered keys
          const reorderedOptionsObject: { [key: string]: any } = {};
          const reorderedansObject: { [key: string]: any } = {};
          const reorderedfeedbackObject: { [key: string]: any } = {};
          const reorderedchecklistObject: { [key: string]: any } = {};
          const reorderedresponseObject: { [key: string]: any } = {};
          const reorderedscoreObject: { [key: string]: any } = {};
          const reorderedoptionsemotionObject: { [key: string]: any } = {};
          const reorderedresponseemotionObject: { [key: string]: any } = {};
          const reorderedoptionTitleObject: { [key: string]: any } = {};
          const reorderedoptionVoiceObject: { [key: string]: any } = {};

          let counter = 0;

          Object.keys(iteration.optionsObject)
            .sort()
            .forEach((key) => {
              const newKey = String.fromCharCode('A'.charCodeAt(0) + counter);

              reorderedOptionsObject[newKey] = iteration.optionsObject[key]
                ? iteration.optionsObject[key]
                : undefined;
              reorderedansObject[newKey] = iteration.ansObject[key]
                ? iteration.ansObject[key]
                : undefined;

              reorderedfeedbackObject[newKey] = iteration.feedbackObject[key]
                ? iteration.feedbackObject[key]
                : undefined;
              reorderedchecklistObject[newKey] = iteration.checklistObject[key]
                ? iteration.checklistObject[key]
                : undefined;

              reorderedresponseObject[newKey] = iteration.responseObject[key]
                ? iteration.responseObject[key]
                : undefined;

              reorderedscoreObject[newKey] = iteration.scoreObject[key]
                ? iteration.scoreObject[key]
                : undefined;

              if (
                iteration.optionsemotionObject &&
                iteration.optionsemotionObject[key]
              ) {
                reorderedoptionsemotionObject[newKey] =
                  iteration.optionsemotionObject[key];
              } else {
                // Handle the case where iteration.responseemotionObject or its property is undefined
                reorderedoptionsemotionObject[newKey] = undefined;
              }

              if (
                iteration.responseemotionObject &&
                iteration.responseemotionObject[key]
              ) {
                reorderedresponseemotionObject[newKey] =
                  iteration.responseemotionObject[key];
              } else {
                // Handle the case where iteration.responseemotionObject or its property is undefined
                reorderedresponseemotionObject[newKey] = undefined;
              }
              reorderedoptionTitleObject[newKey] = iteration.optionTitleObject[
                key
              ]
                ? iteration.optionTitleObject[key]
                : undefined;

              if (
                iteration.optionsvoiceObject &&
                iteration.optionsvoiceObject[key]
              ) {
                reorderedoptionVoiceObject[newKey] =
                  iteration.optionsvoiceObject[key];
              } else {
                // Handle the case where iteration.responseemotionObject or its property is undefined
                reorderedoptionVoiceObject[newKey] = undefined;
              }

              counter++;
            });

          // Set the reordered optionsObject
          iteration.optionsObject = reorderedOptionsObject;
          iteration.ansObject = reorderedansObject;
          iteration.feedbackObject = reorderedfeedbackObject;
          iteration.checklistObject = reorderedchecklistObject;
          iteration.responseObject = reorderedresponseObject;
          iteration.scoreObject = reorderedscoreObject;
          iteration.optionsemotionObject = reorderedoptionsemotionObject;
          iteration.responseemotionObject = reorderedresponseemotionObject;
          iteration.optionTitleObject = reorderedoptionTitleObject;
          iteration.optionsvoiceObject = reorderedoptionVoiceObject;
        } else {
          console.error('optionsObject is not an object');
        }
      } else {
        console.error(`No iteration found with key 'Interaction${seqs}'`);
      }
    } else {
      console.error('Input is not an object');
    }

    const updatedAlphabet = alphabet?.filter(
      (item: any) => !(item.seqs === seqs && item.option === option),
    );

    // Get only the elements with the specific seqs ID
    const filteredBySeqs = updatedAlphabet?.filter(
      (item: any) => item.seqs === seqs,
    );
    if (filteredBySeqs.length === 0) {
      return;
    }

    const rearrangedAlphabet = filteredBySeqs.map((item: any, index: any) => ({
      ...item,
      option: String.fromCharCode(65 + index), // Convert index to alphabet ('A', 'B', ...)
    }));

    setAlphabet((prevAlphabet: any[]) => {
      const filteredPrevAlphabet = prevAlphabet?.filter(
        (item) => item.seqs !== seqs,
      );

      const updatedAlphabet = filteredPrevAlphabet.concat(rearrangedAlphabet);

      return updatedAlphabet;
    });
  }; //1998

  // InteractionBlock Function
  const handleDelResponse = () => {
    setInteractionBlock({ ...interactionBlock, [`Resp${seq.input}`]: null });
  };
  const handleDelCheckList = () => {
    setInteractionBlock({ ...interactionBlock, [`Checklist${seq.input}`]: null });
  };
  const handleDelFeedback = () => {
    setInteractionBlock({ ...interactionBlock, [`Feedbk${seq.input}`]: null });
  };
  const handleDelSkills = () => {
    setInteractionBlock({ ...interactionBlock, [`Skills${seq.input}`]: null });
  };
  const handleDelPriority = () => {
    setInteractionBlock({ ...interactionBlock, [`Priority${seq.input}`]: null });
  };
  const handleDelTitles = () => {
    setInteractionBlock({ ...interactionBlock, [`Title${seq.input}`]: null });
  };

  const [showLeftButton, setShowLeftButton] = useState(false);

  const [showcount, setShowcount] = useState<any>('');

  const handleLeft = () => {
    const container = document.getElementById(seq.id);
    if (container) {
      container.scrollLeft -= 700;
      if (container.scrollLeft <= 0) {
        setShowLeftButton(false);
      }
    }
  };

  const handleRight = () => {
    const container = document.getElementById(seq.id);

    if (container) {
      container.scrollLeft += 700;
      setShowcount(container.scrollLeft + 300);
      if (container.scrollLeft > 0) {
        setShowLeftButton(true);
      }
    }
  };

  const scrollToElement = (inputId: any) => {
    const inputElement = document.getElementById(inputId);

    if (targetRef.current) {
      targetRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  };
  // Styles for Select
  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      // height: '45px',
      width: '200px',
      padding: '0 !important',
    }),
  };

  // Styles for Select QuestionEmotionStyles
  const questionEmotionStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      height: '100%',
      minHeight: '100%',
      width: '150px',
      padding: '0 !important',
      border: validation?.[`QuestionsEmotion${seq.input}`] && '2px solid red',
    }),
  };
  useEffect(() => {
    if (textareaRef.current) {
      // Adjust the height of the textarea based on its content
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;

      // Set the textarea height to adjust the marginTop of the block-score
      setTextareaHeight(textareaRef.current.scrollHeight);
    }
  }, [
    input?.[`Interaction${seq.input}`]?.interaction,
    input?.[`Note${seq.input}`]?.note,
  ]);

  let focusSeqRef: any;
  const justClick = (event: any, seq: any) => {
    if (event.type === 'click') {
      focusSeqRef = document.getElementsByClassName(seq.id);
      const element = focusSeqRef?.[0];
      if (element) {
        element.classList.remove('non-caret');
        element.removeAttribute('readonly');
        element.focus();
      }
    }
  };
  const handleMiniNDInewblock = (
    value?: any,
    seq?: any,
    i?: any,
    option?: any,
  ) => {
    handleNDI(value);
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;

    if (value != '') {
      handleSelectBlock(
        { value: input },
        input,
        option,
        `Interaction${seq.input}`,
      );
    }
  };

  const MiniBox2 = (props: {
    seq?: any;
    i?: number;
    name?: any;
    bodyRef?: any;
  }) => {
    const { seq, i, name, bodyRef } = props;
    return (
      // <Box
      //   position={'absolute'}
      //   background={'#fff'}
      //   p={'10px'}
      //   ml={'-300px'}
      //   boxShadow={'1px 1px 17px #69627914'}
      //   borderRadius={'8px'}
      //   zIndex={99}
      //   right={{ base: '-140px', lg: '' }}
      //   className="MiniShowBox max-h-56 overflow-y-auto"
      // >
       <Box
          position={'absolute'}
          background={'#fff'}
          p={'10px'}
          ml={'-300px'}
          boxShadow={'1px 1px 17px #69627914'}
          borderRadius={'8px'}
          zIndex={9999}
          right={{ base: "-140px", lg: "0" }}
          w="200px"
          maxH="380px"
          overflowY="auto"
          className="MiniShowBox"
        >
       <List cursor={'pointer'}>
                <ListItem
                  onClick={() => handleMiniNDInewblock('Note', seq, i,name)}
                  p={'10px'}
                  display={'flex'}
                  alignItems={'center'}
                  borderBottom={'2px solid #f1f1f170'}
                >
                  <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
                  Note
                </ListItem>
      
                <ListItem
                  onClick={() => handleMiniNDInewblock('Dialog', seq, i,name)}
                  p={'10px'}
                  display={'flex'}
                  alignItems={'center'}
                  borderBottom={'2px solid #f1f1f170'}
                >
                  <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
                  Dialog
                </ListItem>
                <ListItem
                  onClick={() => handleMiniNDInewblock('Interaction', seq, i,name)}
                  p={'10px'}
                  display={'flex'}
                  alignItems={'center'}
                >
                  <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
                  Interaction
                </ListItem>
                <ListItem
                  onClick={() => handleMiniNDInewblock('Link', seq, i,name)}
                  p={'10px'}
                  display={'flex'}
                  alignItems={'center'}
                  borderBottom={'2px solid #f1f1f170'}
                >
                  <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
                  Link
                </ListItem>
                {showReflectionQuestions && (
                  <>
                    <ListItem
                      onClick={() => handleMiniNDInewblock('Reflection', seq, i,name)}
                      p={'10px'}
                      display={'flex'}
                      alignItems={'center'}
                      borderBottom={'2px solid #f1f1f170'}
                    >
                      <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                      Reflection
                    </ListItem>
      
                    <ListItem
                      onClick={() => handleMiniNDInewblock('Overview', seq, i,name)}
                      p={'10px'}
                      display={'flex'}
                      alignItems={'center'}
                      borderBottom={'2px solid #f1f1f170'}
                    >
                      <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                      Overview
                    </ListItem>
                    <ListItem
                      onClick={() => handleMiniNDInewblock('KeyInsights', seq, i,name)}
                      p={'10px'}
                      display={'flex'}
                      alignItems={'center'}
                      borderBottom={'2px solid #f1f1f170'}
                    >
                      <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                      KeyInsights
                    </ListItem>
                    <ListItem
                      onClick={() => handleMiniNDInewblock('PreAssessment', seq, i,name)}
                      p={'10px'}
                      display={'flex'}
                      alignItems={'center'}
                      borderBottom={'2px solid #f1f1f170'}
                    >
                      <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                      PreAssessment
                    </ListItem>
                    <ListItem
                      onClick={() => handleMiniNDInewblock('PostAssessment', seq, i,name)}
                      p={'10px'}
                      display={'flex'}
                      alignItems={'center'}
                      borderBottom={'2px solid #f1f1f170'}
                    >
                      <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                      PostAssessment
                    </ListItem>
                     <ListItem
                                                                                 onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                                                                                 p={'10px'}
                                                                                 display={'flex'}
                                                                                 alignItems={'center'}
                                                                                 borderBottom={'2px solid #f1f1f170'}
                                                                               >
                                                                                 <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                                                                                 WehaveChoose
                                                                               </ListItem>
                                                                                          <ListItem
                                                                                 onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                                                                                 p={'10px'}
                                                                                 display={'flex'}
                                                                                 alignItems={'center'}
                                                                                 borderBottom={'2px solid #f1f1f170'}
                                                                               >
                                                                                 <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                                                                                 Swipe
                                                                               </ListItem>
                                                                                          <ListItem
                                                                                 onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                                                                                 p={'10px'}
                                                                                 display={'flex'}
                                                                                 alignItems={'center'}
                                                                                 borderBottom={'2px solid #f1f1f170'}
                                                                               >
                                                                                 <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                                                                                 Drag For Now 
                                                                               </ListItem>
                  </>
                )}
                {formData?.gameScenarioCompletion === 'true' && (
                  <ListItem
                    onClick={() =>
                      handleMiniNDInewblock('ScenarioCompletion', seq, i,name)
                    }
                    p={'10px'}
                    display={'flex'}
                    alignItems={'center'}
                    borderBottom={'2px solid #f1f1f170'}
                  >
                    <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                    ScenarioCompletion
                  </ListItem>
                )}
              </List>
      </Box>
    );
  };

  const cardRef = useRef(null);
  useEffect(() => {
    if (cardRef.current && seq?.id !== targetSequence?.id) {
      cardRef.current.scrollLeft = 0;
    }
  }, [targetSequence, seq]);

  return (
    <>
      {seq?.id === targetSequence?.id && (
        <Box
          className="goLeft"
          display={'flex'}
          alignItems={'center'}
          height={'100%'}
          position={'absolute'}
          left={0}
        >
          <Button
            onClick={handleLeft}
            position={'absolute'}
            left={0}
            zIndex={99}
            background={'#0000'}
            _hover={{ background: '#0000' }}
            boxShadow={'unset'}
          >
            <Icon as={MdArrowBack} color={'#fff'} />
            <Box
              content='""'
              height={'30px'}
              width={'30px'}
              borderRadius={'30px'}
              zIndex={-9}
              background={'#11047a'}
              position={'absolute'}
            ></Box>
          </Button>
        </Box>
      )}
      {/* )}  */}
      <Box
        id={`${seq.id}`}
        w={'auto'}
        height={'100%'}
        overflowX={seq?.id === targetSequence?.id ? 'scroll' : 'hidden'}
        className="scroll_hide"
        overflowY={'hidden'}
        ref={cardRef}
      >
        <Box w={'max-content'} display={'flex'}>
          <Box className="block-action-icons">
            <Tooltip hasArrow label="Choose New Block">
              <div>
                <Icon
                  as={MdAdd}
                  transitionDelay={'0s !important'}
                  fontSize={'18px'}
                  color={'grey'}
                  mr={'10px'}
                  cursor={'pointer'}
                  onClick={() => getSeq(seq, index, name)}
                />
              </div>
            </Tooltip>
            <Tooltip hasArrow label="Duplicate">
              <div>
                <Icon
                  as={BiSolidDuplicate}
                  transitionDelay={'0.1s !important'}
                  fontSize={'18px'}
                  color={'grey'}
                  mr={'10px'}
                  cursor={'pointer'}
                  onClick={() =>
                    duplicateSeq(
                      seq,
                      index,
                      name,
                      input?.[`Interaction${seq.input}`],
                    )
                  }
                />
              </div>
            </Tooltip>
            <Tooltip hasArrow label="Delete Interaction">
              <div>
                <Icon
                  as={MdDelete}
                  transitionDelay={'0.2s !important'}
                  fontSize={'18px'}
                  color={'grey'}
                  cursor={'pointer'}
                  onClick={() => delSeq(seq, index, name)}
                />
              </div>
            </Tooltip>
          </Box>
          <Box mr={'10px'} fontWeight={'700'} w={'50px'}>
            {seq.id}
          </Box>
          <Box
            height={'100%'}
            w={{ base: '100%', lg: 'auto' }}
            overflow={'hidden'}
            // padding={'5px'}
            display={'flex'}
            alignItems={'center'}
          >
            <Box mr={'10px'} w={{ base: '100%', lg: '150px' }}>
              <Select
                placeholder={'Character...'}
                id="blockRoll"
                name={`Interaction${seq.input}`}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                  control: (provided: any, state: any) => ({
                    ...provided,
                    borderRadius: '15px',
                    height: '40px',
                    borderColor: 'inherit',
                    background: 'transparent',
                    padding: '0 !important',
                    width: '150px',
                  }),
                }}
                options={options}
                value={selectedOption}
                isSearchable={true}
                className="react-select"
                onChange={(selectedOption: any) => {
                  handleBlockRoll(
                    selectedOption,
                    seq.input,
                    `Interaction${seq.input}`,
                  );
                }}
              />
            </Box>
            <Box mr={'10px'} w={{ base: '100%', lg: '400px' }}>
              <Textarea
                placeholder="Interaction - Type your Question"
                id="interaction"
                className={`${seq.id}`}
                name={`Interaction${seq.input}`}
                onChange={handleInput}
                onClick={(e) => justClick(e, seq)}
                value={
                  language
                    ? matchingBlockContent
                    : input?.[`Interaction${seq.input}`]?.interaction
                }
                borderRadius={'15px'}
                style={{
                  overflow: 'hidden',
                  border:
                    validation?.[`Interaction${seq.input}`] && '2px solid red',
                }}
                width={'400px'}
                minHeight="65px"
                height={
                  seq?.id === targetSequence?.id ? 'auto' : '65px !important'
                }
                ref={textareaRef}
                _focusVisible={{
                  borderColor: '#0000',
                  border: '1px solid #e5e5e5',
                  boxShadow: 'unset',
                }}
                tabIndex={0}
                readOnly={true}
              />
            </Box>
            {parseInt(input?.[`Interaction${seq.input}`]?.blockRoll, 10) !==
            99999 ? (
              <Box mr={'10px'} w={{ base: '100%', lg: 'auto' }}>
                <Select
                  placeholder={'Animate...'}
                  id="interaction"
                  name={`Interaction${seq.input}`}
                  menuPortalTarget={document.body}
                  styles={questionEmotionStyles}
                  options={emotionsOptions}
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  className="react-select"
                  value={
                    input?.[`Interaction${seq.input}`]?.QuestionsEmotion
                      ? input?.[
                          `Interaction${seq.input}`
                        ]?.QuestionsEmotion.split(',').map((value: string) => ({
                          value,
                          label: value,
                        }))
                      : []
                  }
                  onChange={(selectedOption: any) =>
                    handleQuestionEmotion(
                      selectedOption,
                      seq.input,
                      `Interaction${seq.input}`,
                    )
                  }
                />
              </Box>
            ) : (
              <Box mr={'10px'} w={'150px'}></Box>
            )}
              <Box
              className="scenario-dropdown"
              mb="10px"
              w={{ base: '100%', lg: '200px' }}
            >
              <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                Select Scenario
              </Text>
            
             <Select
              placeholder="Select Scenario"
              options={scenarioOptions}
              // value={input?.[`Interaction${seq.input}`]?.scenario}
              value={
  scenarioOptions.find(
    (opt) =>
      opt.value === input?.[`Interaction${seq.input}`]?.scenario
  ) || null
}

               styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...provided,
                    borderRadius: '12px',
                    minHeight: '36px',
                  }),
                }}
              onChange={(option: any) =>
                handleInput({
                  name: `Interaction${seq.input}`,
                  value: {
                    // scenario: option,
                    scenario: option?.value,

                  },
                })
              }
              isSearchable={false}
              menuPortalTarget={document.body}
            />
            
            </Box>
            {interactionBlock?.[`Title${[seq.input]}`] == seq.input && (
              <Box
                mr={'10px'}
                w={'470px'}
                ps={'3rem'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Textarea
                  placeholder="Question Title..."
                  name={`Interaction${seq.input}`}
                  onChange={handleInput}
                  value={input?.[`Interaction${[seq.input]}`].quesionTitle}
                  id={`QuestionTitle${seq.input}`}
                  w={'400px'}
                  borderRadius={'15px'}
                  style={{
                    resize: 'none',
                    overflowY: 'hidden',
                    height: inputtextValue,
                  }}
                  _focus={{ height: '100%' }}
                />
                <Icon
                  as={MdDelete}
                  w={5}
                  h={'auto'}
                  onClick={handleDelTitles}
                  color={'grey'}
                />
              </Box>
            )}
            {interactionBlock?.[`Skills${[seq.input]}`] == seq.input && (
              <Box display={'flex'} flexDir={'column'}>
                <Box display={'flex'}>
                  <Textarea
                    id={`skills`}
                    placeholder="Skills..."
                    name={`Interaction${seq.input}`}
                    w={'160px'}
                    // m={'0px 0 15px 10px'}
                    minHeight="40px"
                    borderRadius={'18px'}
                    onChange={handleInput}
                    value={input?.[`Interaction${seq.input}`]?.SkillTag}
                  />
                  <Box
                    m={'10px 0 0px -30px'}
                    w={'100px'}
                    textAlign={'center'}
                    cursor={'pointer'}
                    onClick={handleDelSkills}
                  >
                    <Icon w={5} height={'auto'} as={MdDelete} color={'grey'} />
                  </Box>
                </Box>
              </Box>
            )}
            {interactionBlock?.[`Priority${[seq.input]}`] == seq.input && (
              <Box display={'flex'} flexDir={'column'}>
                <Box display={'flex'}>
                  <Textarea
                    id={`priority`}
                    placeholder="Priority..."
                    name={`Interaction${seq.input}`}
                    w={'160px'}
                    // m={'0px 0 15px 10px'}
                    minHeight="40px"
                    borderRadius={'18px'}
                    onChange={handleInput}
                    value={input?.[`Interaction${seq.input}`]?.PriorityTag}
                  />
                  <Box
                    m={'10px 0 0px -30px'}
                    w={'100px'}
                    textAlign={'center'}
                    cursor={'pointer'}
                    onClick={handleDelPriority}
                  >
                    <Icon w={5} height={'auto'} as={MdDelete} color={'grey'} />
                  </Box>
                </Box>
              </Box>
            )}
            <Box className="block-btns">
              <Box display={'flex'} flexDir={'column'}>
                <Flex flexDir={{ base: 'column', sm: 'row' }}>
                  {interactionBlock?.[`Resp${seq.input}`] !== seq?.input ? (
                    <Button
                      mr={'10px'}
                      w={'130px'}
                      p={5}
                      justifyContent={'start'}
                      onClick={() =>
                        setInteractionBlock((prev: any) => {
                          return { ...prev, [`Resp${[seq.input]}`]: seq.input };
                        })
                      }
                    >
                      <Icon
                        as={MdAdd}
                        bg={'blue'}
                        color={'#fff'}
                        borderRadius={'888px'}
                        mr={'5px'}
                      />{' '}
                      <Text>Response</Text>
                    </Button>
                  ) : null}
                  {interactionBlock?.[`Feedbk${seq.input}`] !== seq?.input ? (
                    <Button
                      mr={'10px'}
                      w={'130px'}
                      p={5}
                      justifyContent={'start'}
                      onClick={() =>
                        setInteractionBlock((prev: any) => {
                          return {
                            ...prev,
                            [`Feedbk${[seq.input]}`]: seq.input,
                          };
                        })
                      }
                    >
                      <Icon
                        as={MdAdd}
                        bg={'blue'}
                        color={'#fff'}
                        borderRadius={'888px'}
                        mr={'5px'}
                      />{' '}
                      <Text>Feedback</Text>
                    </Button>
                  ) : null}
                  {interactionBlock?.[`Checklist${seq.input}`] !== seq?.input ? (
                    <Button
                      mr={'10px'}
                      w={'130px'}
                      p={5}
                      justifyContent={'start'}
                      onClick={() =>
                        setInteractionBlock((prev: any) => {
                          return {
                            ...prev,
                            [`Checklist${[seq.input]}`]: seq.input,
                          };
                        })
                      }
                    >
                      <Icon
                        as={MdAdd}
                        bg={'blue'}
                        color={'#fff'}
                        borderRadius={'888px'}
                        mr={'5px'}
                      />{' '}
                      <Text>Checklist</Text>
                    </Button>
                  ) : null}
                  {interactionBlock?.[`Title${seq.input}`] !== seq?.input ? (
                    <Button
                      mr={'10px'}
                      w={'130px'}
                      p={5}
                      justifyContent={'start'}
                      onClick={() => {
                        setInteractionBlock((prev: any) => {
                          return {
                            ...prev,
                            [`Title${[seq.input]}`]: seq.input,
                          };
                        });
                        scrollToElement(`QuestionTitle${seq.input}`);
                      }}
                    >
                      <Icon
                        as={MdAdd}
                        bg={'blue'}
                        color={'#fff'}
                        borderRadius={'888px'}
                        mr={'5px'}
                      />{' '}
                      <Text>Title</Text>
                    </Button>
                  ) : null}
                  {interactionBlock?.[`Skills${seq.input}`] !== seq?.input ? (
                    <Button
                      mr={'10px'}
                      w={'130px'}
                      p={5}
                      justifyContent={'start'}
                      onClick={() => {
                        setInteractionBlock((prev: any) => {
                          return {
                            ...prev,
                            [`Skills${[seq.input]}`]: seq.input,
                          };
                        });
                        scrollToElement(`skill${seq.input}`);
                      }}
                    >
                      <Icon
                        as={MdAdd}
                        bg={'blue'}
                        color={'#fff'}
                        borderRadius={'888px'}
                        mr={'5px'}
                      />{' '}
                      <Text>Skills</Text>
                    </Button>
                  ) : null}
                  {interactionBlock?.[`Priority${seq.input}`] !== seq?.input ? (
                    <Button
                      mr={'10px'}
                      w={'130px'}
                      p={5}
                      justifyContent={'start'}
                      onClick={() => {
                        setInteractionBlock((prev: any) => {
                          return {
                            ...prev,
                            [`Priority${[seq.input]}`]: seq.input,
                          };
                        });
                        scrollToElement(`priority${seq.input}`);
                      }}
                    >
                      <Icon
                        as={MdAdd}
                        bg={'blue'}
                        color={'#fff'}
                        borderRadius={'888px'}
                        mr={'5px'}
                      />{' '}
                      <Text>Priority</Text>
                    </Button>
                  ) : null}
                </Flex>
              </Box>
            </Box>
          </Box>
        </Box>
        {seq?.id === targetSequence?.id && (
          <Box w={'auto'} h={'100%'} display={'flex'}>
            <Box className="options_interaction" ml={'227px'}>
              <TableContainer>
                <Table variant="unStyled">
                  <Thead>
                    <Tr>
                      <Th textAlign={'center'}></Th>
                      {interactionBlock?.[`Title${[seq.input]}`] ==
                        seq.input && <Th textAlign={'center'}>Title</Th>}
                      {interactionBlock?.[`Resp${[seq.input]}`] ===
                        seq?.input && <Th textAlign={'center'}></Th>}
                      {interactionBlock?.[`Resp${[seq.input]}`] ===
                        seq?.input && (
                        <Th
                          display="flex"
                          alignItems="center"
                          justifyContent={'center'}
                        >
                          Response
                          <Tooltip label="Delete Response" hasArrow>
                            <div>
                              <Icon
                                as={MdDelete}
                                w={5}
                                h={'auto'}
                                onClick={handleDelResponse}
                                cursor={'pointer'}
                                color={'grey'}
                              />
                            </div>
                          </Tooltip>
                        </Th>
                      )}
                      {interactionBlock?.[`Feedbk${[seq.input]}`] ===
                         seq.input && ( 
                          <Th>
                            <Box
                              w={'100%'}
                              display={'flex'}
                              justifyContent={'center'}
                              alignItems={'center'}
                            >
                              FeedBack
                              <Tooltip label="Delete Feedback" hasArrow>
                                <div>
                                  <Icon
                                    as={MdDelete}
                                    w={5}
                                    h={'auto'}
                                    onClick={handleDelFeedback}
                                    cursor={'pointer'}
                                    color={'grey'}
                                  />
                                </div>
                              </Tooltip>
                            </Box>
                          </Th>
                         )}
                        {/* checklist */}
                      {interactionBlock?.[`Checklist${[seq.input]}`] ===
                        seq.input && (
                          <Th>
                            <Box
                              w={'100%'}
                              display={'flex'}
                              justifyContent={'center'}
                              alignItems={'center'}
                            >
                              Checklist
                              <Tooltip label="Delete Checklist" hasArrow>
                                <div>
                                  <Icon
                                    as={MdDelete}
                                    w={5}
                                    h={'auto'}
                                    onClick={handleDelCheckList}
                                    cursor={'pointer'}
                                    color={'grey'}
                                  />
                                </div>
                              </Tooltip>
                            </Box>
                          </Th>
                        )}
                      <Th textAlign={'center'}>Right</Th>
                      <Th textAlign={'center'}>Score</Th>
                      <Th textAlign={'center'}>Navigation</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {alphabet
                      ?.filter((alp: any) => alp.seqs === seq.id)
                      .map((alp: any, i: number, arr: any[]) => {
                        const isLastElement = i === arr.length - 1;
                        const iconId = `deleteIcon_${alp.option}`;
                        return (
                          <Tr>
                            <Td textAlign={'center'}>
                              <Box
                                className="interaction-option"
                                display={'flex'}
                                alignItems={'center'}
                                mb={'10px'}
                              >
                                <Box
                                  className="interaction-option-del-icon"
                                  ml={'-17px'}
                                  mr={'4px'}
                                  cursor={'pointer'}
                                  onClick={() =>
                                    deleteAndRearrange(alp.seqs, alp.option)
                                  }
                                >
                                  <Icon as={MdDelete} color={'grey'} />
                                </Box>
                                <Box
                                  key={alp.option}
                                  position={'relative'}
                                  display={'flex'}
                                  alignItems={'center'}
                                >
                                  <Textarea
                                    placeholder={`Option${alp.option}`}
                                    id={`Option${alp.option}`}
                                    name={`Interaction${seq.input}`}
                                    onChange={handleInput}
                                    pl={'25px'}
                                    onClick={handleInter}
                                    onKeyDown={handleKeyDown}
                                    onBlur={(e: any) => {
                                      handleFocusOut();
                                      // blockOnBlurHanlder(e, seq);
                                    }}
                                    // onFocus={(e:any) => blockOnFocusHanlder(e,seq)}
                                    borderRadius={'15px'}
                                    border={
                                      validation?.[
                                        `options${seq.input}${alp.option}`
                                      ]
                                        ? '2px solid red'
                                        : '1px solid #e5e5e5'
                                    }
                                    title={alp.option}
                                    value={
                                      language
                                        ? (filteredOptions &&
                                            filteredOptions.find(
                                              (option: Option) =>
                                                option.qpOptions === alp.option,
                                            )?.contentOptionTextData[0]
                                              ?.content) ||
                                          ''
                                        : input?.[`Interaction${seq.input}`]
                                            ?.optionsObject?.[alp.option]
                                    }
                                    w={'400px'}
                                    mr={'10px'}
                                    style={{
                                      resize: 'none',
                                      overflowY: 'hidden',
                                      height: 'auto',
                                      border: validation?.[
                                        `options${seq.input}${alp.option}`
                                      ]
                                        ? '2px solid red'
                                        : '1px solid #e5e5e5',
                                    }}
                                    _focus={{ height: '100%' }}
                                  />
                                  <Box>
                                    <Text
                                      position={'absolute'}
                                      top={'13px'}
                                      left={'5px'}
                                      display={'flex'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                      h={'11px'}
                                      w={'11px'}
                                      bg={'#000'}
                                      color={'#fff'}
                                      p={'7px'}
                                      borderRadius={'30px'}
                                      fontSize={'10px'}
                                    >
                                      {alp.option}
                                    </Text>
                                  </Box>

                                  <Box mr={'10px'}>
                                    <Select
                                      placeholder={'Animate...'}
                                      id={`Option${alp.option}`}
                                      name={`Interaction${seq.input}`}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base: any) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                        control: (
                                          provided: any,
                                          state: any,
                                        ) => ({
                                          ...provided,
                                          borderRadius: '15px',
                                          borderColor: 'inherit',
                                          background: 'transparent',
                                          width: '200px',
                                          padding: '0 !important',
                                          border:
                                            validation?.[
                                              `optionsEmotion${seq.input}${alp.option}`
                                            ] && '2px solid red',
                                        }),
                                      }}
                                      options={emotionsOptions}
                                      isSearchable={true}
                                      isClearable={false}
                                      className="react-select"
                                      isMulti={true}
                                      value={
                                        input?.[`Interaction${seq.input}`]
                                          ?.optionsemotionObject?.[alp.option]
                                          ? input?.[
                                              `Interaction${seq.input}`
                                            ]?.optionsemotionObject?.[
                                              alp.option
                                            ]
                                              .split(',')
                                              .map((value: string) => ({
                                                value,
                                                label: value,
                                              }))
                                          : []
                                      }
                                      onChange={(e: any) =>
                                        handleOptionEmotion(
                                          e,
                                          seq.input,
                                          `Option${alp.option}`,
                                          `Interaction${seq.input}`,
                                        )
                                      }
                                    />
                                  </Box>
                                </Box>
                              </Box>
                            </Td>
                            {interactionBlock?.[`Title${[seq.input]}`] ==
                              seq.input && (
                              <Td>
                                <Box mr={'10px'}>
                                  <Box>
                                    <Textarea
                                      placeholder={`Title${alp.option}`}
                                      id={`OptionTitle${alp.option}`}
                                      name={`Interaction${seq.input}`}
                                      onChange={handleInput}
                                      onKeyDown={handleKeyDown}
                                      onBlur={handleFocusOut}
                                      title={alp.option}
                                      value={
                                        input?.[`Interaction${seq.input}`]
                                          ?.optionTitleObject?.[alp.option]
                                      }
                                      pl={'25px'}
                                      mb={'10px'}
                                      borderRadius={'15px'}
                                      w={'400px'}
                                      style={{
                                        resize: 'none',
                                        overflowY: 'hidden',
                                        height: inputtextValue,
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </Td>
                            )}
                            {interactionBlock?.[`Resp${[seq.input]}`] ===
                              seq?.input &&
                              i === 0 && (
                                <Td rowSpan={arr?.length}>
                                  <Select
                                    placeholder={'Character...'}
                                    id="ResponseCharter"
                                    name={`Interaction${seq.input}`}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base: any) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (provided: any, state: any) => ({
                                        ...provided,
                                        borderRadius: '15px',
                                        height: '40px',
                                        borderColor: 'inherit',
                                        background: 'transparent',
                                        padding: '0 !important',
                                        width: '115px',
                                        marginLeft: '4px',
                                      }),
                                    }}
                                    options={options}
                                    value={selectedrespoOption}
                                    isSearchable={true}
                                    className="react-select"
                                    onChange={(selectedOption: any) =>
                                      handleResponseRoll(
                                        selectedOption,
                                        seq.input,
                                        `Interaction${seq.input}`,
                                      )
                                    }
                                  />
                                </Td>
                              )}
                            {interactionBlock?.[`Resp${[seq.input]}`] ===
                              seq?.input && (
                              <Td textAlign={'center'}>
                                <Box
                                  key={i}
                                  position={'relative'}
                                  display={'flex'}
                                  alignItems={'center'}
                                  mb={'10px'}
                                >
                                  <Box mr={'10px'}>
                                    <Textarea
                                      placeholder={'Response'}
                                      id={`Response${alp.option}`}
                                      title={alp.option}
                                      name={`Interaction${seq.input}`}
                                      onChange={handleInput}
                                      onClick={handleInter}
                                      pl={'25px'}
                                      borderRadius={'15px'}
                                      value={
                                        language
                                          ? (ResponseOptions &&
                                              ResponseOptions.find(
                                                (option: Option) =>
                                                  option.qpOptions ===
                                                  alp.option,
                                              )?.contentOptionTextData[0]
                                                ?.content) ||
                                            ''
                                          : input?.[`Interaction${seq.input}`]
                                              ?.responseObject?.[alp.option]
                                      }
                                      w={'200px'}
                                      style={{
                                        resize: 'none',
                                        overflowY: 'hidden',
                                        height: inputtextValue,
                                      }}
                                    />
                                    <Text
                                      position={'absolute'}
                                      top={'13px'}
                                      left={'5px'}
                                      display={'flex'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                      h={'11px'}
                                      w={'11px'}
                                      bg={'#000'}
                                      color={'#fff'}
                                      p={'7px'}
                                      borderRadius={'30px'}
                                      fontSize={'10px'}
                                    >
                                      {alp.option}
                                    </Text>
                                  </Box>
                                  {input?.[`Interaction${seq.input}`]
                                    ?.responseRoll !== 99999 &&
                                    input?.[`Interaction${seq.input}`]
                                      ?.responseRoll !== '99999' && (
                                      <Box>
                                        <Select
                                          placeholder={'Animate...'}
                                          id={`Option${alp.option}`}
                                          name={`Interaction${seq.input}`}
                                          menuPortalTarget={document.body}
                                          styles={customStyles}
                                          options={emotionsOptions}
                                          isSearchable={true}
                                          isClearable={false}
                                          isMulti={true}
                                          className="react-select"
                                          value={
                                            input?.[`Interaction${seq.input}`]
                                              ?.responseemotionObject?.[
                                              alp.option
                                            ]
                                              ? input?.[
                                                  `Interaction${seq.input}`
                                                ]?.responseemotionObject?.[
                                                  alp.option
                                                ]
                                                  .split(',')
                                                  .map((value: string) => ({
                                                    value,
                                                    label: value,
                                                  }))
                                              : []
                                          }
                                          onChange={(e: any) =>
                                            handleResponseEmotion(
                                              e,
                                              seq.input,
                                              `Option${alp.option}`,
                                              `Interaction${seq.input}`,
                                            )
                                          }
                                        />
                                      </Box>
                                    )}
                                </Box>
                              </Td>
                            )}
                            {interactionBlock?.[`Feedbk${[seq.input]}`] ===
                              seq.input && (
                              <Td textAlign={'center'}>
                                <Box display={'flex'} mb={'10px'}>
                                  <Box
                                    key={i}
                                    position={'relative'}
                                    display={'flex'}
                                  >
                                    <Textarea
                                      placeholder={'Feedback'}
                                      id={`FeedBack${alp.option}`}
                                      title={alp.option}
                                      name={`Interaction${seq.input}`}
                                      onChange={handleInput}
                                      onClick={handleInter}
                                      pl={'25px'}
                                      borderRadius={'15px'}
                                      value={
                                        input?.[`Interaction${seq.input}`]
                                          ?.feedbackObject?.[alp.option]
                                      }
                                      mb={'3px'}
                                      w={'200px'}
                                      style={{
                                        resize: 'none',
                                        overflowY: 'hidden',
                                        height: inputtextValue,
                                      }}
                                    />
                                    <Text
                                      position={'absolute'}
                                      top={'13px'}
                                      left={'5px'}
                                      display={'flex'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                      h={'11px'}
                                      w={'11px'}
                                      bg={'#000'}
                                      color={'#fff'}
                                      p={'7px'}
                                      borderRadius={'30px'}
                                      fontSize={'10px'}
                                    >
                                      {alp.option}
                                    </Text>
                                  </Box>
                                </Box>
                              </Td>
                            )}
                            {interactionBlock?.[`Checklist${[seq.input]}`] ===
                              seq.input && (
                                <Td textAlign={'center'}>
                                  <Box display={'flex'} mb={'10px'}>
                                    <Box
                                      key={i}
                                      position={'relative'}
                                      display={'flex'}
                                    >
                                      <Textarea
                                        placeholder={'Checklist'}
                                        id={`Checklist${alp.option}`}
                                        title={alp.option}
                                        name={`Interaction${seq.input}`}
                                        onChange={handleInput}
                                        onClick={handleInter}
                                        pl={'25px'}
                                        borderRadius={'15px'}
                                        value={
                                          input?.[`Interaction${seq.input}`]
                                            ?.checklistObject?.[alp.option]
                                        }
                                        mb={'3px'}
                                        w={'200px'}
                                        style={{
                                          resize: 'none',
                                          overflowY: 'hidden',
                                          height: inputtextValue,
                                        }}
                                      />
                                      <Text
                                        position={'absolute'}
                                        top={'13px'}
                                        left={'5px'}
                                        display={'flex'}
                                        justifyContent={'center'}
                                        alignItems={'center'}
                                        h={'11px'}
                                        w={'11px'}
                                        bg={'#000'}
                                        color={'#fff'}
                                        p={'7px'}
                                        borderRadius={'30px'}
                                        fontSize={'10px'}
                                      >
                                        {alp.option}
                                      </Text>
                                    </Box>
                                  </Box>
                                </Td>
                              )}
                            <Td textAlign={'center'}>
                              <Box>
                                <Checkbox
                                  size="md"
                                  border={
                                    validation?.[`checkbox${seq.input}`] &&
                                    '2px solid red'
                                  }
                                  colorScheme="green"
                                  id={`Ans${alp.option}`}
                                  title={alp.option}
                                  name={`Interaction${seq.input}`}
                                  onChange={(e: any) =>
                                    handleCheckBox(
                                      e,
                                      seq.input,
                                      `Option${alp.option}`,
                                      `Interaction${seq.input}`,
                                    )
                                  }
                                  isChecked={
                                    input?.[`Interaction${seq.input}`]
                                      ?.ansObject?.[alp.option] === true ||
                                    input?.[`Interaction${seq.input}`]
                                      ?.ansObject?.[alp.option] === 'true'
                                  }
                                ></Checkbox>
                              </Box>
                            </Td>
                            <Td textAlign={'center'} p={0}>
                              <Box>
                                <Input
                                  type="text"
                                  borderRadius={'15px'}
                                  border={
                                    validation?.[`score${seq.input}`] &&
                                    '2px solid red'
                                  }
                                  placeholder="00"
                                  id={`Score${alp.option}`}
                                  title={alp.option}
                                  name={`Interaction${seq.input}`}
                                  onChange={handleInput}
                                  onKeyPress={(e) => {
                                    const allowedKeys = [
                                      '0',
                                      '1',
                                      '2',
                                      '3',
                                      '4',
                                      '5',
                                      '6',
                                      '7',
                                      '8',
                                      '9',
                                      'Backspace',
                                      'Delete',
                                      'ArrowLeft',
                                      'ArrowRight',
                                      'Tab',
                                    ];

                                    if (!allowedKeys.includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  value={
                                    input?.[`Interaction${seq.input}`]
                                      ?.scoreObject?.[alp.option]
                                  }
                                  style={{ height: '30px' }}
                                />
                                <span hidden>{alp.option}</span>
                              </Box>
                            </Td>
                            <Td textAlign={'center'}>
                              <Box style={{ marginBottom: '-20px' }}>
                                <Flex mb={'13px'}>
                                  <Box>
                                    <Tooltip hasArrow label="Add Navigations">
                                      <div>
                                        <Menu
                                          tabState={'navigation'}
                                          option={`Option${alp.option}`}
                                          id={seq.input}
                                          for={`Interaction${seq.input}`}
                                          setNavigation={setNavigation}
                                          handleBlock={handleBlock}
                                          items={items}
                                          seq={seq}
                                        />
                                      </div>
                                    </Tooltip>
                                  </Box>

                                  <Box
                                    ml={'4px'}
                                    cursor={'pointer'}
                                    display={
                                      input?.[`Interaction${seq.input}`]
                                        ?.navigateshowObjects?.[alp.option]
                                        ? 'block'
                                        : 'none'
                                    }
                                    position={'relative'}
                                  >
                                    {input?.[`Interaction${seq.input}`]
                                      ?.navigateshowObjects?.[alp.option] ===
                                      'New Block' &&
                                    !input?.[`Interaction${seq.input}`]
                                      ?.navigateObjects?.[alp.option] ? (
                                      <>
                                        <MiniBox2
                                          seq={seq}
                                          i={index}
                                          name={`Option${alp.option}`}
                                        />
                                      </>
                                    ) : input?.[`Interaction${seq.input}`]
                                        ?.navigateshowObjects?.[alp.option] ===
                                        'Select Block' &&
                                      !input?.[`Interaction${seq.input}`]
                                        ?.navigateObjects?.[alp.option] ? (
                                      <Select
                                        placeholder={'Blocks...'}
                                        id="interaction"
                                        name={`Interaction${seq.input}`}
                                        menuPortalTarget={document.body}
                                        styles={customStyles}
                                        options={showSelectBlock.filter(
                                          (option: any) =>
                                            option.value !== seq.input,
                                        )}
                                        isSearchable={true}
                                        className="react-select"
                                        value={
                                          showSelectBlock.find(
                                            (option: any) =>
                                              option.value ==
                                              input?.[`Interaction${seq.input}`]
                                                ?.navigateObjects?.[alp.option],
                                          ) || null
                                        }
                                        onChange={(e: any) =>
                                          handleSelectBlock(
                                            e,
                                            seq.input,
                                            `Option${alp.option}`,
                                            `Interaction${seq.input}`,
                                          )
                                        }
                                      />
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '164px',
                                          }}
                                        >
                                          <StrightConector
                                            name={
                                              input?.[`Interaction${seq.input}`]
                                                ?.navigateshowObjects?.[
                                                alp.option
                                              ] === 'New Block'
                                                ? showSelectBlock.find(
                                                    (option: any) =>
                                                      option.value ==
                                                      input?.[
                                                        `Interaction${seq.input}`
                                                      ]?.navigateObjects?.[
                                                        alp.option
                                                      ],
                                                  )?.label
                                                : input?.[
                                                    `Interaction${seq.input}`
                                                  ]?.navigateshowObjects?.[
                                                    alp.option
                                                  ] === 'Select Block'
                                                ? showSelectBlock.find(
                                                    (option: any) =>
                                                      option.value ==
                                                      input?.[
                                                        `Interaction${seq.input}`
                                                      ]?.navigateObjects?.[
                                                        alp.option
                                                      ],
                                                  )?.label
                                                : input?.[
                                                    `Interaction${seq.input}`
                                                  ]?.navigateObjects?.[
                                                    alp.option
                                                  ]
                                            }
                                          />
                                        </div>
                                      </>
                                    )}
                                  </Box>
                                </Flex>
                              </Box>
                            </Td>
                          </Tr>
                        );
                      })}
                    <Tr>
                      <Td>
                        <Box
                          position={'relative'}
                          opacity={0.6}
                          cursor={'pointer'}
                          onClick={(e) => {
                            const currentOptions = alphabet?.filter(
                              (alp: any) => alp.seqs === seq.id,
                            );
                            if (currentOptions.length >= 5) {
                              toast({
                                title: 'Limit Reached',
                                description: 'Only 5 options can be created.',
                                status: 'error',
                                duration: 3000,
                                isClosable: true,
                              });
                              return;
                            }
                            handleSubmit(e);
                          }}
                          display={'flex'}
                        >
                          <Box visibility={'hidden'} w={'20px'}>
                            <Icon as={MdDelete} />
                          </Box>
                          <Input
                            placeholder={'Add Option'}
                            name={alphabet}
                            pl={'25px'}
                            borderRadius={'10px'}
                            tabIndex={1}
                            style={{ pointerEvents: 'none' }}
                            w={'240px'}
                          />
                          <Text
                            position={'absolute'}
                            top={'13px'}
                            left={'25px'}
                            display={'flex'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            h={'11px'}
                            w={'11px'}
                            bg={'#000'}
                            color={'#fff'}
                            p={'7px'}
                            borderRadius={'30px'}
                            fontSize={'10px'}
                          ></Text>
                        </Box>
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        )}
      </Box>
      {seq?.id === targetSequence?.id && (
        <Box
          className="goRight"
          display={'flex'}
          alignItems={'center'}
          height={'100%'}
          position={'absolute'}
          right={0}
        >
          <Button
            onClick={handleRight}
            position={'absolute'}
            right={0}
            zIndex={999}
            background={'#0000'}
            _hover={{ background: '#0000' }}
            boxShadow={'unset'}
          >
            <Icon as={MdArrowForward} color={'#fff'} />
            <Box
              content='""'
              height={'30px'}
              width={'30px'}
              borderRadius={'30px'}
              zIndex={-9}
              background={'#11047a'}
              position={'absolute'}
            ></Box>
          </Button>
        </Box>
      )}
    </>
  );
};

export default InteractionCompo;
